import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  DOMElement,
  useMemo,
  useLayoutEffect,
} from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Divider,
  Grid,
  LinearProgress,
  Paper,
  Backdrop,
  Skeleton,
  Slide,
  useScrollTrigger,
  Drawer,
  Typography,
  FormControl,
  InputLabel,
  Select,
  SelectChangeEvent,
  MenuItem,
  Card,
  CardContent,
  ClickAwayListener,
  IconButton,
  Pagination,
  Modal,
  TextField,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@mui/material';
import constructionImage from '../../assets/construction.svg';
import dummyMarketHistoricalData from '../../assets/dummy_market_historical_data.json';
import CloseIcon from '@mui/icons-material/Close';
import RefreshIcon from '@mui/icons-material/Refresh';
import _debounce from 'lodash/debounce';
import {
  DiscoveryCountryCodeType,
  InsightsDashboardPropTypes,
  VisibleListingsProp,
} from 'src/interfaces/iproptypes';
import TravelExploreRoundedIcon from '@mui/icons-material/TravelExploreRounded';
import CompareIcon from '@mui/icons-material/Compare';
import { Tooltip, makeStyles } from '@material-ui/core';
import {
  AVAILABLE_COUNTRY,
  COLOR_PRIMARY,
  COLOR_PRIMARY_DARK,
  COLOR_TOOLTIP_BACKGROUND,
  COLOR_WHITE,
  DOWNLOAD_CSV_KEY_METRICS,
  DOWNLOAD_CSV_LISTINGS_LTM_DATA,
  FILTER_FLOAT_BUTTON_Z_INDEX,
  HEADER_HEIGHT,
  MAP_VIEW_TOOLTIP_MAPPING,
  MAX_ROI_FOR_MARKET_GRAD_IN_OVERVIEW,
  MIN_ROI_FOR_MARKET_GRAD_IN_OVERVIEW,
  OVERVIEW_DASHBOARD_FILTER_DEMO_DATA,
  POINTER_GREEN,
  exchangeRates,
  sidebarClosedWidth,
  sidebarWidth,
  userDisplayFriendlyCountryCode,
} from 'src/const';
import ArrowRightRoundedIcon from '@mui/icons-material/ArrowRightRounded';
import MapIcon from '@mui/icons-material/Map';
import DashboardIcon from '@mui/icons-material/Dashboard';
import TuneRoundedIcon from '@mui/icons-material/TuneRounded';
import Map from './HOC/Map';
import MainKPICard from './UtilityComponents/MainKPICard';
import './styles/styles.scss';
import { getDistrictInfo, getUserInfo, setUserInfo } from 'src/store/Dashboard/actions';
import { useDispatch, useSelector } from 'react-redux';
import { styled } from '@material-ui/core';
import DownloadIcon from '@mui/icons-material/Download';
import TabBar from 'src/App/Components/Tabs/TabBar';
import {
  COLOR_ERROR_1,
  COLOR_PRIMARY_2,
  COLOR_SECONDARY_1_300,
  COLOR_SECONDARY_1_600,
  COLOR_TEXT_2,
  COLOR_SUCCESS_1,
  DEFAULT_TEXT_COLOR,
  HISTORICAL_BARGRAPH_COLOR,
  KPI_CARD_COLOR,
  LISTING_COUNT_BAR_GRAPH_COLOR,
  COLOR_SECONDARY_2,
  COLOR_SECONDARY_2_600,
  COLOR_SECONDARY_2_700,
  COLOR_TERTIARY_1_600,
  COLOR_PRIMARY_1,
  COLOR_PRIMARY_1_500,
  COLOR_GREY_600,
  COLOR_TEXT_1,
  SIDEBAR_COLOR,
  COLOR_PRIMARY_1_100,
} from 'src/colors';
import MapFilter from './HOC/MapFilter';
import {
  BarDataCard,
  HorizontalBarCard,
  LoadingCard,
  SupplyCard,
  TooltipCard,
} from 'src/App/HOC/Cards';
import RevenuePotentialByPropertySizeCard from 'src/App/Pages/OverviewPage/UtilityComponents/RevenuePotentialByPropertySizeCard';
import GranularDataCard from 'src/App/HOC/Cards/GranularDataCard';
import HistoricalDataKPICard from 'src/App/Pages/OverviewPage/UtilityComponents/HistoricalDataKPICard';
import PropertySizeCard from 'src/App/Pages/OverviewPage/UtilityComponents/PropertySizeCard';
import PropertyTypeChannelPieChart from 'src/App/Pages/OverviewPage/UtilityComponents/PropertyTypeChannelPieChart';
import AmenityCard from 'src/App/Pages/OverviewPage/UtilityComponents/AmenityCard';
import ExtraPricingCard from 'src/App/Pages/OverviewPage/UtilityComponents/ExtraPricingCard';
import TopCitiesCard from 'src/App/Pages/OverviewPage/UtilityComponents/TopCitiesCard';
import TopCountriesCard from 'src/App/Pages/OverviewPage/UtilityComponents/TopCountriesCard';
import InternationDomesticGuestsCard from 'src/App/Pages/OverviewPage/UtilityComponents/InternationDomesticGuestsCard';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import ArrowRightAltRoundedIcon from '@mui/icons-material/ArrowRightAltRounded';
import LockSharpIcon from '@material-ui/icons/LockSharp';
import Hosts from 'src/App/Pages/OverviewPage/UtilityComponents/Hosts';
import GuestLanguageCard from 'src/App/Pages/OverviewPage/UtilityComponents/GuestLanguageCard';
import ListingsTable from './HOC/ListingsTable';
import ConfirmUnlockRegionModal from 'src/App/Modals/ConfirmUnlockRegionModal';
import { callApi } from 'src/core/callApi';
import {
  abbreviateNumber,
  convertCurrency,
  convertListingsDictToArray,
  deepCopyObject,
  exportMarketOverview,
  exportSampleData,
  formatCurrency,
  getDiscoveryMarketsURLCountryWise,
  getHistoricalMarketPerformance,
  getListingCSVDataAsArray,
  getRedirectedDiscoveryMarketCountryCode,
  isEmpty,
  isObject,
  makeDownloadableBlob,
  makeLowerCase,
  parseMessageHistoricalData,
  safeMarkersLoad,
  cacheApiCall,
  getCachedApiCall,
  updateDynamoDBForUserVerification,
  trackUserDynamicDataUpdateAttempt,
} from 'src/utils/functions';
import mixpanel from 'mixpanel-browser';
import { ToastContainer, toast } from 'react-toastify';
import BottomDrawer from './HOC/BottomDrawer';
import {
  processAndSortMarketLevelData,
  getHistoricalData,
  getMarketLevelAggregateData,
  getYoYChange,
  sortListingsByPerformance,
  processCompareData,
  getMinmaxROI,
  getScoreColorAndValue,
  extractVisibleListingIDs,
  sortListingBasedOnKey,
  // simulateTenYearsROI,
} from './helper';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { FullScreenAnimationLoader } from 'src/App/Components/Loaders';
import { InfoTooltip } from 'src/App/HOC/Tooltips';
import IndividualOnBoardingPage from '../IndividualOnBoardingPage';
import investmentLandingPage from 'src/App/assets/house-bg-home.jpg';
import { ZoomButtons } from './UtilityComponents/ZoomButtons';
import NoDataCard from 'src/App/HOC/Cards/NoDataCard';
import SingleBarFilterCard from './HOC/FilterComponents/SingleBarFilterCard';
import SimplifiedAirbnbPointerBody from 'src/App/HOC/Cards/SimplifiedAirbnbPointerBody';
import { Listing } from 'src/interfaces/idashboard';
import { infoIconButton, infoIconStyle } from 'src/App/Dashboards/Market/styles/style';
import { LTMMonthlyDataType, LTMMonthlyPerformanceBreakdownType } from 'src/interfaces/apiTypes';
import { IndividualListingModal } from 'src/App/Modals';
import DiscoveryTab from './HOC/DiscoveryTab';
import CompareTab from './HOC/CompareTab';
import { DecisionDialog } from 'src/App/Components';
import { useHistory, useParams } from 'react-router-dom';
import BottomDiscoveryDrawer from './HOC/BottomDiscoveryDrawer';
import topData from '../../../../src/top_us_markets.json';
import allData from '../../../../src/all_us_markets.json';
import DiscoveryAi from '../DiscoveryAi/DiscoveryAi';
import postOnSlack from 'src/core/postOnSlack';

const MAP_SIZE_MAP_VIEW_DESKTOP = 40;

const useStylesRoot = makeStyles(theme => ({
  tooltip: {
    padding: 0,
    backgroundColor: 'transparent !important',
    margin: '0px !important',
  },
  popperInteractive: {
    width: '350px !important',
  },
  tooltipIcon: {
    position: 'relative',
    width: '100px',
    height: '30px',
    background: '#fff',
    color: '#000',
    borderRadius: 100,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: '0 2px 4px #0004, 0 2px 10px #0002',
    transform: 'translate(-50%, -50%)',
    transition: 'background 0.3s ease, color 0.3s ease',
    '&:hover': {
      background: '#000',
      color: '#fff',
    },
  },
}));

const redirectToDefaultRegionIfNeeded = (dispatch, pathname, redirectSearchPageQuery) => {
  if (
    (pathname === '/airbnb-data' || pathname === '/airbnb-data/') &&
    redirectSearchPageQuery !== 'true'
  ) {
    const redirectTo = '/airbnb-data/united-kingdom/0/the%20city%20of%20brighton%20and%20hove';
    window.history.pushState({}, '', redirectTo);
    dispatch(getDistrictInfo('the city of brighton and hove', '0', 'united-kingdom'));
  }
};

const getSelectedViewWidth = (
  view: 'map' | 'dashboard' | 'discovery' | 'compare',
  matches: boolean,
  isMapVisbleOnFullScreen: boolean,
  isDiscoveryAIVisible: boolean = false
) => {
  if (matches) {
    return view == 'map' ? 100 : 0;
  } else {
    if (view == 'map') {
      return MAP_SIZE_MAP_VIEW_DESKTOP;
    } else if (view == 'discovery' && isDiscoveryAIVisible) {
      return 0;
    } else if (view == 'discovery' && isMapVisbleOnFullScreen) {
      return 100;
    } else {
      return 20;
    }
  }
};

const ExportButtonOptionTooltip = ({ body, children }) => {
  return (
    <InfoTooltip
      title={
        <Card>
          <CardContent style={{ background: COLOR_TOOLTIP_BACKGROUND }}>
            <Grid container direction="column" alignItems="flex-start">
              {body}
            </Grid>
          </CardContent>
        </Card>
      }
    >
      {children}
    </InfoTooltip>
  );
};

const getMapViewHeadings = (text1: string, text2: string) => {
  return (
    <Grid
      item
      xs={12}
      sx={{
        marginBottom: '10px',
        display: 'flex',
        alignItems: 'center',
        gap: 1,
      }}
    >
      <Typography
        variant="h5"
        className="marketTitle"
        sx={{
          fontSize: '20px',
          fontWeight: 'bold',
          position: 'relative',
          top: '5px',
          marginBottom: '20px',
        }}
      >
        {text1}: <span>{text2}</span>
      </Typography>
    </Grid>
  );
};

const OverviewPage = ({
  search,
  isUserAllowed,
  isLoggedIn,
  dashboardLayoutView,
  setDashboardLayoutView,
  listings,
  otaListings,
  staticListings,
  multipleMarkersCallLoading,
  multipleOTAMarkersCallLoading,
  titleCase,
  visibleListings,
  visibleOTAListings,
  dynamicVisibleListings,
  setDynamicVisibleListings,
  sample,
  dashboardState,
  openAlert,
  setOpenAlert,
  setOTAListings,
  matches,
  filterApplied,
  setListings,
  dynamicTrigger,
  setDynamicTrigger,
  subscriptionModalOpen,
  setSubscriptionModalOpen,
  overviewDashboardMode,
  currency,
  user,
  showSearchCreditDeductWarningModal,
  setShowSearchCreditDeductWarningModal,
  searchLimitAlertBox,
  setSearchLimitAlertBox,
  getMarkers,
  handleOnSampleClick,
  bookingData,
  multipleBookingMarkersCallLoading,
  isHighlight,
  highlightElement,
  removeHighlightElement,
  filterVal,
  filterActive,
  setFilterActive,
  isEmailVerifyModalOpen,
  isUserVerified,
  setIsEmailVerifyModalOpen,
  rateLimitAlert,
  setRateLimitAlert,
  revPotentialRangeInvestment,
  getHighLowRevPotentialInvestment,
  bounds,
  setBounds,
  OnBoardingSearchBox,
  setIndividualRevenuePotentialRange,
  applyFilter,
  filteredListings,
  filteredOTAListings,
  setIsTailoredRegionOpen,
  updateShowAppTour,
  showAppTour,
  toggleDrawer,
  sidebarOpen,
  setFilterVal,
  graph,
  cachedMarketData,
  setLoginModalOpen,
  filteredListingsDashboard,
  topPerformingMarketOnFocus,
  setTopPerformingMarketOnFocus,
}: InsightsDashboardPropTypes) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const params = useParams() as any;
  const userCountryCode = useSelector(state => (state as any).dashboard.userCountryCode);

  const redirectSearchPageQuery =
    new URLSearchParams(window.location.search).get('searchPage') || '-1';

  redirectToDefaultRegionIfNeeded(dispatch, window.location.pathname, redirectSearchPageQuery);

  let isDisabled: boolean = !isUserAllowed;
  const [mapWidth, setMapWidth] = useState<0 | 20 | 40 | 100>(
    getSelectedViewWidth('dashboard', matches, false)
  );

  const [visibleListingIDs, setVisibleListingIDs] = useState<string[]>([]);
  const [visibleOTAListingIDs, setVisibleOTAListingIDs] = useState<string[]>([]);
  const [isDynamicDataInitialized, setIsDynamicDataInitialized] = useState(false);
  const [isDynamicDataBtnVisible, setIsDynamicDataBtnVisible] = useState(false);
  const [dashboardScrollPositionTop, setDashboardScrollPositionTop] = useState<number>(0);
  const [subKpiSelected, setSubKpiSelected] = useState<string>('revenue');
  const [subKpiMapViewSelected, setSubKpiMapViewSelected] = useState<string>('listings');
  const [openTop10ManagerModal, setOpenTop10ManagerModal] = useState<boolean>(false);

  const [zoom, setZoom] = useState<number>(12);

  const [extraCreditDeductModal, setExtraCreditDeductModal] = useState<boolean>(false);
  const [fullExportAccess, setFullExportAccess] = useState<boolean>(false);

  const [extraExportCreditsLoading, setExtraExportCreditsLoading] = useState<boolean>(false);
  const [extraExportError, setExtraExportError] = useState<boolean>(false);
  const [creditsToBeDeducted, setCreditsToBeDeducted] = useState<number>(1);

  const [marketLevelOccupancyRate, setMarketLevelOccupancyRate] = useState<Number>(0);
  const [marketLevelRevenuePotential, setMarketLevelRevenuePotential] = useState<number>(0);
  const [marketLevelDailyRate, setMarketLevelDailyRate] = useState<number>(0);
  const [marketLevelActiveListings, setMarketLevelActiveListings] = useState<Number>(0);
  const [isDiscoveryMapViewOpen, setIsDiscoveryMapViewOpen] = useState<boolean>(true);
  const [occupancyRateHistoricalData, setOccupancyRateHistoricalData] = useState<any>([]);
  const [revenueHistoricalData, setRevenueHistorical] = useState<any>([]);
  const [dailyRateHistoricalData, setDailyRateHistorical] = useState<any>([]);
  const [listingHistoricalData, setListingHistorical] = useState<any>([]);
  const [occupancyPast6MonthsHistoricalData, setOccupancyPast6MonthsHistorical] = useState<any>([]);
  const [revenuePast6MonthsHistoricalData, setRevenuePast6MonthsHistorical] = useState<any>([]);
  const [dailyRatePast6MonthsHistoricalData, setDailyRatePast6MonthsHistorical] = useState<any>([]);
  const [listingPast6MonthsHistoricalData, setListingPast6MonthsHistorical] = useState<any>([]);
  const [occupancyYoYChange, setOccupancyYoYChange] = useState<Number>();
  const [revenueYoYChange, setRevenueYoYChange] = useState<Number>();
  const [dailyYoYChange, setDailyYoYChange] = useState<Number>();
  const [listingYoYChange, setListingYoYChange] = useState<Number>();
  const [isMapViewMainKpiCardTooltipOpen, setIsMapViewMainKpiCardTooltipOpen] = useState<boolean[]>(
    [false, false, false, false]
  ); //occupancy, revenue, nightly, listings

  const [isScoreCardTooltipOpen, setIsScoreCardTooltipOpen] = useState<boolean>(false);
  const [isMarketCachedDataLoaded, setIsMarketCachedDataLoaded] = useState<boolean>(false);
  const [cachedHistoricalData, setCachedHistoricalData] = useState<{
    [key: string]: { [key: string]: number };
  } | null>(null);
  const [cachedLTMData, setCachedLTMData] = useState<{ [key: string]: number } | null>(null);
  const [
    cachedMonthlyLTMData,
    setCachedMonthlyLTMData,
  ] = useState<LTMMonthlyPerformanceBreakdownType | null>(null);

  const [
    confirmSaveCountryPlanMarketModalOpen,
    setConfirmSaveCountryPlanMarketModalOpen,
  ] = useState<boolean | undefined>(false);

  const [showPremiumDataDynamic, setShowPremiumDataDynamic] = useState<boolean>(true);

  const [topPerformingListingOnFocus, setTopPerformingListingOnFocus] = useState<string | null>(
    null
  );

  const [showNeighbourhood, setShowNeighbourhood] = useState(false);
  const [listingsGridStartIndexOffset, setListingsGridStartIndexOffset] = useState<number>(0);
  const [topPerformingListingModalOpen, setTopPerformingListingModalOpen] = useState<string | null>(
    null
  );

  const [discoveryMarkets, setDiscoveryMarkets] = useState<any[] | null | undefined>([]);
  const [minROI, setMinROI] = useState(0);
  const [maxROI, setmaxROI] = useState(0);
  const [searchedMarketROI, setSearchedMarketROI] = useState(0);
  const [searchedMarketNetRentalYield, setSearchedMarketNetRentalYield] = useState(0);

  const [isTabChanging, setIsTabChanging] = useState<boolean>(false);
  const [showDiscoveryAI, setShowDiscoveryAI] = useState<boolean>(false);

  // Commenting the calculation for overview marketgrad as we dont need it
  // useEffect(() => {
  //   if (search.data.countryCode == 'US' && cachedLTMData) {
  //     const annualAppreciation = parseInt(search['data']['annualAppreciation']);
  //     const propertyPrice = parseInt(search['data']['property_price']);
  //     const revenue = cachedLTMData['adr'] * (cachedLTMData['occupancy_rate'] / 100) * 366;
  //     let avgExpense = 0.4 * revenue;
  //     let netRentalYield = ((revenue - avgExpense) / propertyPrice) * 100;
  //     setSearchedMarketNetRentalYield(netRentalYield);
  //     let roi = simulateTenYearsROI(propertyPrice, netRentalYield, annualAppreciation);
  //     setSearchedMarketROI(roi);
  //   }
  // }, [search, cachedLTMData]);

  const [isDiscoveryMarketLoading, setIsDiscoveryMarketLoading] = useState<boolean>(true);

  const [marketsToCompareList, setMarketsToCompareList] = useState<any[]>([]);

  const [discoverTabData, setDiscoveryTabData] = useState<any>([]);

  const [topRawMarketData, setTopRawMarketData] = useState<any[]>([]);
  const [allRawMarketData, setAllRawMarketData] = useState<any[]>([]);
  const [discoveryMarketType, setDiscoveryMarketType] = useState<'all' | 'top'>('top');
  const [processedMarketData, setProcessedMarketData] = useState<any[]>([]);
  const [allMarketProcessedData, setAllMarketProcessedData] = useState<any[]>([]);
  const [isMarketDataAccessible, setIsMarketDataAccessible] = useState<boolean>(false);
  const [freeTopMarketData, setFreeTopMarketData] = useState<any[]>([]);
  const [freeAllMarketData, setFreeAllMarketData] = useState<any[]>([]);
  const [freeMarketDataKey, setFreeMarketDataKey] = useState<string[]>([]);
  const [showDiscoveryAlertModal, setShowDiscoveryAlertModal] = useState<boolean>(false);
  const [showAlertForWhichFeature, setShowAlertForWhichFeature] = useState<string>('');
  const subKPIcontainerRef = useRef<HTMLDivElement | null>(null);
  const [showIndividualListingFormModal, setShowIndividualListingFormModal] = useState<boolean>(
    false
  );
  const subKPIcontainerMapViewRef = useRef<HTMLDivElement | null>(null);
  const warningToastRef = useRef<React.ReactText | undefined>(undefined);
  const dynamicLoadingMapViewKPI =
    (dashboardLayoutView === 'map' || dashboardLayoutView === 'dashboard') && dynamicTrigger;
  const [listingSortingKey, setListingSortingKey] = useState<string>('performance');

  const [selectedDiscoveryCountry, setSelectedDiscoveryCountry] = useState<
    DiscoveryCountryCodeType
  >(
    params.country && Object.keys(AVAILABLE_COUNTRY).includes(params.country.toUpperCase())
      ? params.country.toUpperCase()
      : ''
  );

  const [filteredDiscoveryMarketsSet, setFilteredDiscoveryMarketsSet] = useState<Set<string>>(
    new Set<string>()
  );

  const noDataInMarket = !multipleMarkersCallLoading && listings.data && isEmpty(listings.data);
  const rootClass = useStylesRoot();

  if ((window as any).Tawk_API) {
    (window as any).Tawk_API.onLoad = () => {
      (window as any).Tawk_API.hideWidget();
    };
  }

  useEffect(() => {
    setFilteredDiscoveryMarketsSet(
      new Set(
        discoverTabData.map(
          market => (market.district + market.city + market.countryCode) as string
        )
      )
    );
  }, [discoverTabData]);

  useEffect(() => {
    if (localStorage.getItem('openDiscovery') == 'true') {
      setDashboardLayoutView('discovery');
      localStorage.setItem('openDiscovery', 'false');
    }
  }, [localStorage.getItem('openDiscovery')]);

  useEffect(() => {
    userCountryCode &&
      selectedDiscoveryCountry == '' &&
      (Object.keys(AVAILABLE_COUNTRY).includes(userCountryCode)
        ? setSelectedDiscoveryCountry(userCountryCode)
        : setSelectedDiscoveryCountry('US'));
  }, [userCountryCode]);

  useEffect(() => {
    const fetchData = async () => {
      setMarketsToCompareList([]);
      setIsDiscoveryMarketLoading(true);
      try {
        const TOP_MARKET_URL = getDiscoveryMarketsURLCountryWise(selectedDiscoveryCountry, 'top');
        const cachedTopMarketData = await getCachedApiCall(TOP_MARKET_URL);
        const top_market_res = cachedTopMarketData
          ? cachedTopMarketData.data
          : await callApi(TOP_MARKET_URL, {}, true);

        if (!cachedTopMarketData) {
          await cacheApiCall(TOP_MARKET_URL, top_market_res);
        }

        if (top_market_res.message.is_premium) {
          setTopRawMarketData(top_market_res.message.markets);
          setIsMarketDataAccessible(true);
        } else {
          setTopRawMarketData([
            ...top_market_res.message.sample_markets,
            ...top_market_res.message.markets,
          ]);
          setFreeTopMarketData(top_market_res.message.sample_markets);
        }

        const ALL_MARKET_URL = getDiscoveryMarketsURLCountryWise(selectedDiscoveryCountry, 'all');
        const cachedAllMarketData = await getCachedApiCall(ALL_MARKET_URL);
        const all_market_res = cachedAllMarketData
          ? cachedAllMarketData.data
          : await callApi(ALL_MARKET_URL, {}, true);

        if (!cachedAllMarketData) {
          await cacheApiCall(ALL_MARKET_URL, all_market_res);
        }

        if (all_market_res.message.is_premium) {
          setAllRawMarketData(all_market_res.message.markets);
          setIsMarketDataAccessible(true);
        } else {
          setAllRawMarketData([
            ...all_market_res.message.sample_markets,
            ...all_market_res.message.markets,
          ]);
          setFreeAllMarketData(all_market_res.message.sample_markets);
        }
        setIsDiscoveryMarketLoading(false);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
      isDiscoveryMarketLoading && setIsDiscoveryMarketLoading(false);
    };

    selectedDiscoveryCountry && fetchData();
  }, [selectedDiscoveryCountry]);

  useEffect(() => {
    let freeMarketKey: string[] = [];
    let visibleMarketData = discoveryMarketType == 'top' ? freeTopMarketData : freeAllMarketData;
    for (let data of visibleMarketData) {
      let key = `${data.district}-${data.city}-${data.country_code}`;
      freeMarketKey.push(key);
    }
    setFreeMarketDataKey(freeMarketKey);
  }, [freeTopMarketData, freeAllMarketData, discoveryMarketType]);

  useEffect(() => {
    if (topRawMarketData.length > 0 && allRawMarketData.length > 0) {
      let processedData;
      const rawData = discoveryMarketType === 'top' ? topRawMarketData : allRawMarketData;
      if (isMarketDataAccessible) {
        processedData = processAndSortMarketLevelData(rawData);
      } else {
        processedData = processAndSortMarketLevelData(rawData, true);
      }

      // Processing All market Data for compare tab
      let allMarketProcessedData = [];
      if (isMarketDataAccessible) {
        allMarketProcessedData = processAndSortMarketLevelData(allRawMarketData);
        setAllMarketProcessedData(allMarketProcessedData);
      } else {
        allMarketProcessedData = processAndSortMarketLevelData(allRawMarketData, true);
        setAllMarketProcessedData(allMarketProcessedData);
      }

      setProcessedMarketData(processedData);
      setDiscoveryMarkets(processedData);
      const [min, max] = getMinmaxROI(rawData);
      setMinROI(min);
      setmaxROI(max);
    }
  }, [topRawMarketData, allRawMarketData, discoveryMarketType]);

  useEffect(() => {
    if (visibleListingIDs.length > 0 && !isDynamicDataInitialized) {
      setDynamicVisibleListings(visibleListings);
      setIsDynamicDataInitialized(true);
    }
  }, [visibleListingIDs]);

  useEffect(() => {
    if (!cachedMarketData.loading && cachedMarketData.data) {
      setCachedHistoricalData(cachedMarketData.data?.historical_monthly_performance);
      cachedMarketData.data?.ltm_performance &&
        setCachedLTMData(cachedMarketData.data?.ltm_performance);
      cachedMarketData.data?.ltm_performance && setIsMarketCachedDataLoaded(true);
      cachedMarketData.data?.ltm_monthly_performance_breakdown &&
        setCachedMonthlyLTMData(cachedMarketData.data.ltm_monthly_performance_breakdown);
    }
  }, [cachedMarketData]);

  useEffect(() => {
    setMapWidth(getSelectedViewWidth(dashboardLayoutView, matches, false));
  }, [matches]);

  useEffect(() => {
    if (dashboardLayoutView === 'map') {
      setMapWidth(getSelectedViewWidth('map', matches, false));

      const mapViewTop = document.getElementById('overviewRight');
      mapViewTop && mapViewTop.scrollTo(0, 0);
    } else if (dashboardLayoutView === 'discovery') {
      setMapWidth(getSelectedViewWidth('discovery', matches, false, showDiscoveryAI));
    }
  }, [dashboardLayoutView, showDiscoveryAI]);

  const [blockListingExport, setBlockListingExport] = useState<boolean>(false);

  useEffect(() => {
    if (user && user.blockListingExport) {
      setBlockListingExport(true);
    }
    setShowDiscoveryAI(user.showDiscoveryAI);
  }, [user]);

  useEffect(() => {
    if (isLoggedIn && !isUserAllowed) {
      setTimeout(() => {
        if (user.credits > 0) {
          setShowSearchCreditDeductWarningModal(true);
        }
      }, 5020);
    }
  }, [isUserAllowed, isLoggedIn]);

  useEffect(() => {
    if (!visibleListings.loading && visibleListings.data.length > 0) {
      setVisibleListingIDs(extractVisibleListingIDs(visibleListings.data));
      setVisibleOTAListingIDs(extractVisibleListingIDs(visibleOTAListings.data));
    }
  }, [visibleListings, visibleOTAListings]);

  const closeIndividualListingFormModal = () => {
    setShowIndividualListingFormModal(false);
  };

  const setHistoricalGraphData = (
    historicalMarketPerformanceData,
    type: 'full' | 'sample' = 'sample'
  ) => {
    const [dailyRateHistoricalData, dailyYoYChange] = getHistoricalData(
      historicalMarketPerformanceData,
      'daily',
      currency
    );

    setDailyRateHistorical(dailyRateHistoricalData);
    setDailyRatePast6MonthsHistorical(dailyRateHistoricalData.slice(-6));
    setDailyYoYChange(dailyYoYChange);

    if (type === 'full') {
      const [occupancyRateHistoricalData, occupancyYoYChange] = getHistoricalData(
        historicalMarketPerformanceData,
        'occupancy',
        currency
      );

      const [revenueHistoricalData, revenueYoYChange] = getHistoricalData(
        historicalMarketPerformanceData,
        'revenue',
        currency
      );

      const [listingHistoricalData, listingYoYChange] = getHistoricalData(
        historicalMarketPerformanceData,
        'listing',
        currency
      );

      setOccupancyRateHistoricalData(occupancyRateHistoricalData);
      setRevenueHistorical(revenueHistoricalData);
      setListingHistorical(listingHistoricalData);
      setOccupancyPast6MonthsHistorical(occupancyRateHistoricalData.slice(-6));
      setRevenuePast6MonthsHistorical(revenueHistoricalData.slice(-6));
      setListingPast6MonthsHistorical(listingHistoricalData.slice(-6));
      setOccupancyYoYChange(occupancyYoYChange);
      setRevenueYoYChange(revenueYoYChange);
      setListingYoYChange(listingYoYChange);
    }
  };

  useEffect(() => {
    const marketLevelOccupancyRate =
      dashboardLayoutView !== 'map' && cachedLTMData
        ? cachedLTMData['occupancy_rate']
        : getMarketLevelAggregateData(
            dashboardLayoutView == 'map' ? dynamicVisibleListings.data : staticListings.data,
            isDisabled,
            'insights',
            'Occupancy Rate',
            currency,
            'process'
          );

    const marketLevelRevenue =
      dashboardLayoutView !== 'map' && cachedLTMData
        ? cachedLTMData['revenue']
        : getMarketLevelAggregateData(
            dashboardLayoutView == 'map' ? dynamicVisibleListings.data : staticListings.data,
            isDisabled,
            'insights',
            'Revenue',
            currency,
            'process'
          );

    const marketLevelDailyRate =
      dashboardLayoutView !== 'map' && cachedLTMData
        ? cachedLTMData['adr']
        : getMarketLevelAggregateData(
            dashboardLayoutView == 'map' ? dynamicVisibleListings.data : staticListings.data,
            isDisabled,
            'insights',
            'Nightly Rate',
            currency,
            'process'
          );

    const marketLevelAvailiableListing =
      dashboardLayoutView !== 'map' && cachedLTMData
        ? cachedLTMData['supply']
        : dashboardLayoutView == 'map'
        ? visibleListings.data.length
        : staticListings.data.length;
    setMarketLevelOccupancyRate(marketLevelOccupancyRate);
    setMarketLevelRevenuePotential(marketLevelRevenue);
    setMarketLevelDailyRate(marketLevelDailyRate);
    setMarketLevelActiveListings(marketLevelAvailiableListing);

    if (cachedHistoricalData) {
      setHistoricalGraphData(
        cachedHistoricalData,
        cachedMarketData.data?.is_user_allowed ? 'full' : 'sample'
      );
    }
  }, [dynamicVisibleListings, cachedHistoricalData, cachedMarketData]);

  const handleSubKPITabClick = (tabId: string) => {
    const element = document.getElementById(tabId);
    if (element) {
      // Create a new element above the selected element
      const newElement = document.createElement('div');
      newElement.style.height = '1px';
      newElement.style.position = 'relative';
      newElement.style.top = dashboardLayoutView === 'map' ? '-165px' : '-200px';

      // Insert the new element before the selected element
      element.parentNode && element.parentNode.insertBefore(newElement, element);

      // Scroll to the new element
      newElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });

      setTimeout(() => {
        newElement && newElement.remove();
      }, 300);
    }
  };

  const ExportButtonOptionTooltip = ({ body, children }) => {
    return (
      <InfoTooltip
        title={
          <Card>
            <CardContent style={{ background: COLOR_TOOLTIP_BACKGROUND }}>
              <Grid container direction="column" alignItems="flex-start">
                {body}
              </Grid>
            </CardContent>
          </Card>
        }
      >
        {children}
      </InfoTooltip>
    );
  };

  const handleOnClickTabLoading = (isMapWidthChanging: boolean = true) => {
    setIsTabChanging(isMapWidthChanging ? true : false);
  };

  const overviewDashboardTabs = [
    {
      label: 'Map',
      value: 'map',
      icon: <MapIcon />,
      onclick: () => {
        handleOnClickTabLoading(mapWidth !== MAP_SIZE_MAP_VIEW_DESKTOP);
        setMapWidth(MAP_SIZE_MAP_VIEW_DESKTOP);
        setDashboardLayoutView('map');
        window.history.pushState(
          {},
          'overview',
          `/airbnb-data/${search.data.country ? search.data.country : 0}/${
            search.data.city ? search.data.city : 0
          }/${search.data.name}`
        );
      },
    },
    {
      label: 'Dashboard',
      value: 'dashboard',
      icon: <DashboardIcon />,
      onclick: () => {
        handleOnClickTabLoading(mapWidth !== getSelectedViewWidth('dashboard', matches, false));
        setMapWidth(getSelectedViewWidth('dashboard', matches, false));
        setDashboardLayoutView('dashboard');
        window.history.pushState(
          {},
          'overview',
          `/airbnb-data/${search.data.country ? search.data.country : 0}/${
            search.data.city ? search.data.city : 0
          }/${search.data.name}`
        );
      },
    },
    {
      label: 'Discovery',
      value: 'discovery',
      icon: <TravelExploreRoundedIcon />,
      onclick: () => {
        // if (userCountryCode !== 'US' || userCountryCode !== 'GB' || userCountryCode !== 'AU') {
        //   setShowAlertForWhichFeature('discovery');
        //   setShowDiscoveryAlertModal(true);
        // } else {
        mapWidth !== getSelectedViewWidth('discovery', matches, false) &&
          handleOnClickTabLoading(true);
        setMapWidth(getSelectedViewWidth('discovery', matches, false, showDiscoveryAI));
        setDashboardLayoutView('discovery');
        window.history.pushState(
          {},
          'overview',
          `/markets/${getRedirectedDiscoveryMarketCountryCode(selectedDiscoveryCountry)}`
        );
        // }
      },
    },
    {
      label: 'Compare',
      value: 'compare',
      icon: <CompareIcon />,
      onclick: () => {
        // if (userCountryCode !== 'US' || userCountryCode !== 'GB' || userCountryCode !== 'AU') {
        //   setShowAlertForWhichFeature('compare');
        //   setShowDiscoveryAlertModal(true);
        // } else {
        handleOnClickTabLoading(mapWidth !== getSelectedViewWidth('compare', matches, false));
        setMapWidth(getSelectedViewWidth('compare', matches, false));
        setDashboardLayoutView('compare');
        window.history.pushState(
          {},
          'overview',
          `/markets/${getRedirectedDiscoveryMarketCountryCode(selectedDiscoveryCountry)}`
        );
        // }
      },
    },
  ];

  const subKpiTabsMetadata = [
    {
      label: 'Overview',
      value: 'overview',
      onclick: () => {
        setSubKpiSelected('overview');
        handleSubKPITabClick('overview-tab');
      },
    },
    {
      label: 'Supply',
      value: 'supply',
      onclick: () => {
        setSubKpiSelected('supply');
        handleSubKPITabClick('supply-tab');
      },
    },
    {
      label: 'ADR',
      value: 'adr',
      onclick: () => {
        setSubKpiSelected('adr');
        handleSubKPITabClick('adr-tab');
      },
    },
    {
      label: 'Occupancy',
      value: 'occupancy',
      onclick: () => {
        setSubKpiSelected('occupancy');
        handleSubKPITabClick('occupancy-tab');
      },
    },
    {
      label: 'Host',
      value: 'host',
      onclick: () => {
        setSubKpiSelected('host');
        handleSubKPITabClick('host-tab');
      },
    },
  ];

  const subKpiTabsMapViewMetadata = [
    {
      label: 'Revenue',
      value: 'revenue',
      onclick: () => {
        setSubKpiMapViewSelected('revenue');
        handleSubKPITabClick('map-revenue-tab');
      },
    },
    {
      label: 'Supply',
      value: 'supply',
      onclick: () => {
        setSubKpiMapViewSelected('supply');
        handleSubKPITabClick('map-supply-tab');
      },
    },
    {
      label: 'ADR',
      value: 'adr',
      onclick: () => {
        setSubKpiMapViewSelected('adr');
        handleSubKPITabClick('map-adr-tab');
      },
    },
    {
      label: 'Host',
      value: 'host',
      onclick: () => {
        setSubKpiMapViewSelected('host');
        handleSubKPITabClick('map-host-tab');
      },
    },
  ];

  const isInViewport = (element: HTMLElement | null) => {
    if (!element) return false;
    const rect = element.getBoundingClientRect();
    return rect.top <= 420;
  };

  const handleScroll = _debounce((event: Event) => {
    const scrollPosition: number = (event.target as HTMLElement).scrollTop;
    setDashboardScrollPositionTop(scrollPosition);

    dashboardLayoutView === 'dashboard' &&
      subKpiTabsMetadata.forEach(subKpiSection => {
        if (isInViewport(document.getElementById(`${subKpiSection.value}-tab`))) {
          setSubKpiSelected(subKpiSection.value);
        }
      });

    subKpiTabsMapViewMetadata.forEach(subKpiSection => {
      if (isInViewport(document.getElementById(`map-${subKpiSection.value}-tab`))) {
        setSubKpiMapViewSelected(subKpiSection.value);
      }
    });
  }, MAP_SIZE_MAP_VIEW_DESKTOP);

  const handleResizeEndDashboardView = () => {
    setIsTabChanging(false);
  };

  useEffect(() => {
    const rightViewElement = document.getElementById('overviewRight');
    rightViewElement && rightViewElement.addEventListener('scroll', handleScroll);

    // Observes the resize handling for Map Container
    const leftMapView = document.getElementById('overviewLeft');
    leftMapView && leftMapView.addEventListener('transitionend', handleResizeEndDashboardView);

    return () => {
      rightViewElement && rightViewElement.removeEventListener('scroll', handleScroll);
      leftMapView && leftMapView.removeEventListener('transitionend', handleResizeEndDashboardView);
    };
  }, []);

  const warningAlert = (text: string) =>
    (warningToastRef.current = toast.error(text, {
      autoClose: 500000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: 'colored',
      draggablePercent: 60,
    }));
  const infoAlert = (text: string) =>
    toast.warning(text, {
      autoClose: 500000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: 'colored',
      draggablePercent: 60,
    });

  const successAlert = (text: string) =>
    toast.success(text, {
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: 'colored',
      draggablePercent: 60,
    });

  //exporting individual listings data
  const exportIndividualListings = (freeAccessAllListings = false, access10kListings = false) => {
    if (fullExportAccess === true) {
      freeAccessAllListings = true;
    }
    if (Object.keys(listings).length === 0) {
      warningAlert('No listings found to export');
      return;
    }
    let allListings = Object.values(listings.data);
    let data = getListingCSVDataAsArray(allListings as Listing[], currency);

    //if user dosen't have the access to >10K listings
    if (!freeAccessAllListings) {
      //here modal will open to ask for 10K listings or all listings
      //if the length of the data is more than 10K
      if (!access10kListings && data.length > 10000) {
        setExtraCreditDeductModal(true);
        return;
      }
      //slicing the array to 10K if user is not allowed to >10K listings
      data = data.slice(0, 10000);
    }

    makeDownloadableBlob(
      data,
      `${
        search.data && search.data.name ? search.data.name.replaceAll(' ', '_') : 'exported'
      }_data_${currency}`
    );
  };

  const exportDataHandler = (exportIndivListings: boolean) => {
    if (isDisabled || blockListingExport) {
      exportSampleData(mixpanel, exportIndivListings);
      return;
    }

    let full_access: boolean = false;

    //checking if all listings of this region is subscribed or not
    user.regions.forEach((data, index) => {
      if (
        makeLowerCase(search.data.name) ===
        makeLowerCase(isObject(data) && 'region' in data ? data.region : data)
      ) {
        full_access = data.full_export_access ? data.full_export_access : false;
        setFullExportAccess(full_access);
      }
    });

    if (exportIndivListings) {
      exportIndividualListings(full_access);
    } else {
      exportMarketOverview(staticListings, search, currency, mixpanel);
    }
  };

  const handleDownloadCSV = (type: string) => {
    switch (type) {
      case DOWNLOAD_CSV_LISTINGS_LTM_DATA:
        exportDataHandler(true);
        return true;
      case DOWNLOAD_CSV_KEY_METRICS:
        exportDataHandler(false);
        return true;
      default:
        return false;
    }
  };

  const deductCredits = async () => {
    setExtraExportCreditsLoading(true);

    //user don't have enough credits so let them see the subscription modal
    if (user.credits === 0 || user.credits < creditsToBeDeducted - 1) {
      setSubscriptionModalOpen(true);
      setExtraExportCreditsLoading(false);
      return;
    }

    const url = 'https://w1ec9zcvbk.execute-api.us-east-2.amazonaws.com/default/getUserInfo';
    const { message } = await callApi(
      url,
      {
        queryParams: {
          creditsToBeDeducted: creditsToBeDeducted,
          market: makeLowerCase(search.data.name),
        },
      },
      true
    );

    //if they don't have enough credits then show them not enough credits error
    if (message === 'Not enough credits') {
      setExtraExportError(true);
      return;
    }
    dispatch(setUserInfo(message));

    setFullExportAccess(true);
    setExtraExportCreditsLoading(false);
    exportIndividualListings(true); //passing true as we want to get the whole data now.
  };

  const handleConfirmSaveCountryPlanMarket = async () => {
    const URL =
      'https://sd9mpt9sy7.execute-api.us-east-2.amazonaws.com/default/addMarketInCountryPlanUser';
    const res = await callApi(
      URL,
      {
        queryParams: {
          name: search.data.name,
          city: search.data.city,
          countryCode: search.data.countryCode,
        },
      },
      true
    );
    return res;
  };

  const handleSaveCountryPlanMarketApiResponse = (res: any) => {
    if (res.message?.error) {
      infoAlert(res.message?.error?.toString());
      return;
    }
    successAlert('Market is saved successfully!');
    setConfirmSaveCountryPlanMarketModalOpen(undefined);
    return;
  };

  const syncDynamicListingsWithVisibleListings = () => {
    setDynamicTrigger(true);
    setDynamicVisibleListings(visibleListings);
    setTimeout(() => {
      setDynamicTrigger(false);
      setIsDynamicDataBtnVisible(false);
      trackUserDynamicDataUpdateAttempt();
    }, 500);
  };

  const dashboardLoadingScreenFullSize = (
    <Grid container spacing={2} sx={{ padding: '20px' }}>
      <Grid item xs={12}>
        {/* Use the loading animation twice to fill the page */}
        {[1, 2].map(_ => (
          <>
            <Skeleton height={120} sx={{ borderRadius: 4 }} />
            <Skeleton height={60} animation="wave" sx={{ borderRadius: 4 }} />
            <Skeleton height={40} sx={{ borderRadius: 4 }} />
            <Skeleton height={50} animation="wave" sx={{ borderRadius: 4 }} />
          </>
        ))}
      </Grid>
    </Grid>
  );

  const DiscoveryAlertModal = () => {
    return (
      <Modal
        open={showDiscoveryAlertModal}
        onClose={() => setShowDiscoveryAlertModal(false)}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            position: 'relative',
            width: '400px',
            backgroundColor: 'white',
            borderRadius: '8px',
            padding: '20px',
            textAlign: 'center',
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              top: '10px',
              right: '10px',
              display: 'flex',
              justifyContent: 'flex-end',
              cursor: 'pointer',
            }}
            onClick={() => {
              setShowDiscoveryAlertModal(false);
            }}
          >
            <CloseIcon />
          </Box>
          <Box sx={{ height: '130px', width: '100%' }}>
            <img
              src={constructionImage}
              alt="Construction"
              style={{ height: '100%', width: '100%' }}
            />
          </Box>
          <Box>
            <Typography variant="h6" sx={{ fontWeight: 500, padding: '10px 0px' }}>
              Market Discovery coming soon!
            </Typography>
            <Typography variant="body2" sx={{ textAlign: 'center' }}>
              While we're hard at work fine-tuning our{' '}
              <span style={{ color: COLOR_PRIMARY_1, cursor: 'pointer' }}>
                {showAlertForWhichFeature == 'discovery' ? 'Discovery' + ' ' : 'Compare' + ' '}
              </span>
              feature for the Canada, Australia & European markets, why not dive in and discover
              what’s in store by checking out the insights available for the{' '}
              {userDisplayFriendlyCountryCode[selectedDiscoveryCountry]}?
            </Typography>
          </Box>
          <Grid xs={12} container spacing={1} sx={{ marginTop: '10px' }}>
            <Grid item xs={6}>
              <Button
                sx={{
                  backgroundColor: '#000',
                  width: '100%',
                  color: '#ffff',
                  marginTop: '10px',
                  borderRadius: '10px',
                  '&:hover': { backgroundColor: '#000' },
                }}
                onClick={() => setShowDiscoveryAlertModal(false)}
              >
                Got it
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button
                sx={{
                  backgroundColor: COLOR_PRIMARY,
                  width: '100%',
                  color: '#ffff',
                  marginTop: '10px',
                  borderRadius: '10px',
                  '&:hover': { backgroundColor: COLOR_PRIMARY_1_500 },
                }}
                onClick={() => {
                  (mapWidth !== getSelectedViewWidth(dashboardLayoutView, matches, false) ||
                    dashboardLayoutView === 'map') &&
                    handleOnClickTabLoading();
                  showAlertForWhichFeature == 'discovery'
                    ? setDashboardLayoutView('discovery')
                    : setDashboardLayoutView('compare');
                  window.history.pushState(
                    {},
                    'overview',
                    `/markets/${getRedirectedDiscoveryMarketCountryCode(selectedDiscoveryCountry)}`
                  );
                  setShowDiscoveryAlertModal(false);
                  setShowAlertForWhichFeature('');
                  setMapWidth(
                    getSelectedViewWidth(
                      showAlertForWhichFeature == 'discovery' ? 'discovery' : 'compare',
                      matches,
                      false
                    )
                  );
                }}
              >
                {showAlertForWhichFeature == 'discovery'
                  ? `Discover ${userDisplayFriendlyCountryCode[selectedDiscoveryCountry]} Markets` +
                    ' '
                  : `Compare ${userDisplayFriendlyCountryCode[selectedDiscoveryCountry]} Markets` +
                    ' '}
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    );
  };

  const IndividualListingFormModal = () => {
    const [email, setEmail] = useState<string>(user.email);
    const [shareDataPulically, setShareDataPulically] = useState<string>('');
    const [companyName, setCompanyName] = useState<string>('');
    const [dataType, setDataType] = useState<string>('');
    const [market, setMarket] = useState<string>(search.data.name);
    const [additionNote, setAdditionalNote] = useState<string>('');

    const handleSampleExportDataClick = () => {
      let url =
        'https://airbtics-resource.s3.us-east-2.amazonaws.com/SAMPLE_EXPORT_DATA/SAMPLE_LISTINGS_DATA.csv';
      let FileName = 'sample_listing_data.csv';
      if (dataType === 'performance') {
        url =
          'https://airbtics-resource.s3.us-east-2.amazonaws.com/SAMPLE_EXPORT_DATA/SAMPLE_PERFORMANCE_DATA.csv';
        FileName = 'sample_performance_data.csv';
      }
      if (dataType === 'both') {
        url =
          'https://airbtics-resource.s3.us-east-2.amazonaws.com/SAMPLE_EXPORT_DATA/SAMPLE_DATA.zip';
        FileName = 'sample_data.zip';
      }
      const link: HTMLAnchorElement = document.createElement('a');
      link.href = url;
      link.setAttribute('download', FileName);
      document.body.appendChild(link);
      link.click();
      if (link && link.nodeType && link.nodeType === Node.ELEMENT_NODE) {
        document.body.removeChild(link);
      }
    };

    const handleOnSubmitExportDataClick = async () => {
      let message = `Export Listing Data Form Submit\nUser: ${email}\nWant to share data publicly: ${shareDataPulically}\nCompany name/Individual use: ${companyName}\n Export type data: ${dataType}\n Market: ${market}\n Additional notes: ${additionNote}`;
      let sendSlackMessage = await postOnSlack('C072095QUU9', message);
      closeIndividualListingFormModal();
    };

    return (
      <Modal
        open={showIndividualListingFormModal}
        onClose={closeIndividualListingFormModal}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Grid
          container
          item
          // xs={12}
          sx={{
            backgroundColor: 'white',
            borderRadius: '8px',
            maxHeight: matches ? '500px' : '700px',
            position: 'relative',
            width: '40%',
            minWidth: '300px',
          }}
        >
          <Box sx={{ position: 'absolute', top: '10px', right: '10px' }}>
            <CloseIcon
              sx={{ cursor: 'pointer', color: SIDEBAR_COLOR }}
              onClick={closeIndividualListingFormModal}
            />
          </Box>
          <Grid
            item
            xs={12}
            sx={{
              height: '50px',
              padding: '10px',
              backgroundColor: COLOR_PRIMARY_1,
              border: 'none',
              color: SIDEBAR_COLOR,
              borderBottomLeftRadius: '12px',
              borderBottomRightRadius: '12px',
              fontWeight: 'bold',
              boxShadow: '0 4px 12px #0002',
            }}
          >
            <Typography variant="h5" sx={{ textAlign: 'center' }}>
              Request to Export to CSV
            </Typography>
          </Grid>
          <Grid
            container
            item
            xs={12}
            sx={{ maxHeight: matches ? '330px' : '530px', overflow: 'auto' }}
          >
            <Grid
              container
              item
              xs={12}
              sx={{
                padding: '20px 40px',
              }}
            >
              <Grid item xs={12}>
                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                  Email:
                </Typography>
                <TextField
                  id="outlined-basic"
                  label=""
                  variant="outlined"
                  fullWidth
                  value={email}
                  onChange={e => {
                    setEmail(e.target.value);
                  }}
                  sx={{
                    '& .MuiOutlinedInput-input': {
                      padding: '10px',
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} sx={{ marginTop: '15px' }}>
                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                  Do you need to share this data publicly?
                </Typography>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={shareDataPulically}
                  onChange={e => {
                    setShareDataPulically(e.target.value);
                  }}
                >
                  <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                  <FormControlLabel value="no" control={<Radio />} label="No" />
                </RadioGroup>
              </Grid>
              <Grid item xs={12} sx={{ marginTop: '15px' }}>
                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                  What is your company name? or is this for individual use?
                </Typography>
                <TextField
                  id="outlined-basic"
                  label=""
                  variant="outlined"
                  fullWidth
                  value={companyName}
                  onChange={e => {
                    setCompanyName(e.target.value);
                  }}
                  sx={{
                    '& .MuiOutlinedInput-input': {
                      padding: '10px',
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} sx={{ marginTop: '15px' }}>
                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                  Which data do you want?
                </Typography>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={dataType}
                  onChange={e => {
                    setDataType(e.target.value);
                  }}
                >
                  <FormControlLabel value="listing" control={<Radio />} label="Listings data" />
                  <FormControlLabel
                    value="performance"
                    control={<Radio />}
                    label="Performance data"
                  />
                  <FormControlLabel value="both" control={<Radio />} label="Both" />
                </RadioGroup>
                {dataType && (
                  <Button
                    sx={{
                      backgroundColor: COLOR_PRIMARY_2,
                      color: SIDEBAR_COLOR,
                      '&:hover': { backgroundColor: COLOR_PRIMARY_2, color: SIDEBAR_COLOR },
                    }}
                    onClick={handleSampleExportDataClick}
                  >
                    Download Sample
                  </Button>
                )}
              </Grid>
              <Grid item xs={12} sx={{ marginTop: '15px' }}>
                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                  Markets (Write countries if you need nationwide data)
                </Typography>
                <TextField
                  id="outlined-basic"
                  label=""
                  variant="outlined"
                  fullWidth
                  value={market}
                  onChange={e => {
                    setMarket(e.target.value);
                  }}
                  sx={{
                    '& .MuiOutlinedInput-input': {
                      padding: '10px',
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} sx={{ marginTop: '15px' }}>
                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                  Any Other Notes?
                </Typography>
                <TextField
                  id="outlined-multiline-static"
                  label=""
                  variant="outlined"
                  fullWidth
                  multiline
                  value={additionNote}
                  onChange={e => {
                    setAdditionalNote(e.target.value);
                  }}
                  rows={2}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sx={{ height: '60px', padding: '10px' }}>
            <Button
              sx={{
                width: '100%',
                backgroundColor: COLOR_PRIMARY_1,
                color: SIDEBAR_COLOR,
                borderRadius: '10px',
                '&:hover': { backgroundColor: COLOR_PRIMARY_1, color: SIDEBAR_COLOR },
              }}
              onClick={handleOnSubmitExportDataClick}
            >
              Submit
            </Button>
          </Grid>
        </Grid>
      </Modal>
    );
  };

  const MainKPICardMemoed = noDataInMarket ? (
    <NoDataCard height={150} borderRadius={8} />
  ) : listings.data && !Object.keys(listings.data).length && !cachedLTMData ? (
    <LoadingCard height={150} type="bars" />
  ) : (
    <Box
      sx={{
        width: '100%',
        height: '400px',
        boxShadow: '0 4px 10px #0003',
        borderRadius: '8px',
      }}
    >
      <MainKPICard
        isDisabled={isDisabled}
        dummyData={
          parseMessageHistoricalData(deepCopyObject(dummyMarketHistoricalData))
            .historical_monthly_performance
        }
        currency={currency}
        marketLevelOccupancyRate={marketLevelOccupancyRate}
        occupancyYoYChange={occupancyYoYChange}
        marketLevelRevenuePotential={marketLevelRevenuePotential}
        marketLevelDailyRate={marketLevelDailyRate}
        revenueYoYChange={revenueYoYChange}
        dailyYoYChange={dailyYoYChange}
        marketLevelActiveListings={marketLevelActiveListings}
        listingYoYChange={listingYoYChange}
        occupancyRateHistoricalData={occupancyRateHistoricalData}
        occupancyPast6MonthsHistoricalData={occupancyPast6MonthsHistoricalData}
        revenueHistoricalData={revenueHistoricalData}
        revenuePast6MonthsHistoricalData={revenuePast6MonthsHistoricalData}
        dailyRateHistoricalData={dailyRateHistoricalData}
        dailyRatePast6MonthsHistoricalData={dailyRatePast6MonthsHistoricalData}
        listingHistoricalData={listingHistoricalData}
        listingPast6MonthsHistoricalData={listingPast6MonthsHistoricalData}
        matches={matches}
        handleOnSampleClick={handleOnSampleClick}
      />
    </Box>
  );

  const PropertyTypeFilterCardSingleBar = (
    <SingleBarFilterCard
      title="Property Type"
      catagoryMap={{
        entire_home: { name: 'Entire Home' },
        private_room: { name: 'Private Room' },
      }}
      optionalCatagoryMap={{
        condo: { name: 'Apartment / Condo', isActive: false },
        hotel_room: { name: 'Hotel Room', isActive: false },
        shared_room: { name: 'Shared Room', isActive: false },
      }}
      isLoading={filteredListingsDashboard.loading}
      data={filteredListingsDashboard.data?.propertyType}
      metricTabs={['occupancyRate', 'adr', 'revenue']}
      color={COLOR_PRIMARY}
      currency={currency}
      handleOnSampleClick={handleOnSampleClick}
      showSelectionChips={true}
      showLTMGraphTooltip={true}
      tooltipText={'See what property type is most in demand in this market.'}
      isGraphSizeSmall={true}
      maxBarSize={13}
      graphTooltipLTMData={cachedMonthlyLTMData ? cachedMonthlyLTMData.property_type : null}
      isGraphLocked={false}
      isDisabled={isDisabled}
      titleHighlightType={'prefix'}
    />
  );

  const PropertySizeFilterCardSingleBar = (
    <SingleBarFilterCard
      title="Property Size"
      catagoryMap={{
        studio: { name: 'Studio' },
        '1': { name: '1' },
        '2': { name: '2' },
        '3': { name: '3' },
        '4': { name: '4' },
        '5': { name: '5' },
        '6+': { name: '6+' },
      }}
      tooltipTitleSuffix="Bedroom"
      isLoading={filteredListingsDashboard.loading}
      data={filteredListingsDashboard.data?.propertySize}
      metricTabs={['occupancyRate', 'adr', 'revenue']}
      color={COLOR_SECONDARY_2_700}
      currency={currency}
      isDisabled={isDisabled}
      handleOnSampleClick={handleOnSampleClick}
      showLTMGraphTooltip={true}
      xAxisTitle={'Bedrooms'}
      tooltipText={'See what is the best number of bedrooms for Airbnb in this market.'}
      isGraphSizeSmall={true}
      maxBarSize={13}
      graphTooltipLTMData={cachedMonthlyLTMData ? cachedMonthlyLTMData.bedroom : null}
      isGraphLocked={isDisabled}
      titleHighlightType={'prefix'}
      xAxisOrder={['studio', '1', '2', '3', '4', '5', '6+']}
    />
  );

  const BathroomNumberFilterCardSingleBar = (
    <SingleBarFilterCard
      title="Bathrooms"
      catagoryMap={{
        '1': { name: '1' },
        '2': { name: '2' },
        '3': { name: '3' },
        '4': { name: '4' },
        '5': { name: '5' },
        '6+': { name: '6+' },
      }}
      tooltipTitleSuffix="Bathroom"
      isLoading={filteredListingsDashboard.loading}
      data={filteredListingsDashboard.data?.bathroomNumber}
      metricTabs={['occupancyRate']}
      color={COLOR_SECONDARY_1_600}
      currency={currency}
      isDisabled={isDisabled}
      handleOnSampleClick={handleOnSampleClick}
      maxBarSize={13}
      isGraphSizeSmall={true}
      xAxisTitle={'Bathrooms'}
      tooltipText={'See how the number of bathrooms of a property impacts its occupancy rate.'}
      isGraphLocked={isDisabled}
    />
  );

  const AdrRangeFilterCardSingleBar = (
    <SingleBarFilterCard
      title="Average Daily Rate"
      catagoryMap={'dynamicRange'}
      isLoading={filteredListingsDashboard.loading}
      data={filteredListingsDashboard.data?.adrRange}
      metricTabs={['occupancyRate']}
      color={COLOR_SECONDARY_2_600}
      currency={currency}
      isXaxisCurrency={true}
      isDisabled={isDisabled}
      handleOnSampleClick={handleOnSampleClick}
      maxBarSize={13}
      isGraphSizeSmall={true}
      tooltipText={'See how the average daily rate of a property impacts its occupancy rate.'}
      dynamicTooltipCatagory={['Budget', 'Economy', 'Midscale', 'Upscale', 'Luxury']}
      isGraphLocked={isDisabled}
    />
  );

  const RatingRangeFilterCardSingleBar = (
    <SingleBarFilterCard
      title="Ratings"
      catagoryMap={{
        '0-4': { name: 'below 4' },
        '4-4.3': { name: '4-4.3' },
        '4.3-4.6': { name: '4.3-4.6' },
        '4.6-4.8': { name: '4.6- 4.8' },
        '4.8-5.1': { name: '4.8-5' },
      }}
      tooltipTitleSuffix={'★ ratings'}
      isLoading={filteredListingsDashboard.loading}
      data={filteredListingsDashboard.data?.ratingRange}
      metricTabs={['occupancyRate']}
      color={COLOR_PRIMARY}
      currency={currency}
      handleOnSampleClick={handleOnSampleClick}
      isDisabled={isDisabled}
      maxBarSize={13}
      isGraphSizeSmall={true}
      xAxisTitle={'ratings out of 5★'}
      tooltipText={'See how the review rating of a property impacts its occupancy rate.'}
      isGraphLocked={isDisabled}
    />
  );

  const MinNightRangeFilterCardSingleBar = (
    <SingleBarFilterCard
      title="Minimum Nights"
      catagoryMap={{
        '1-6': { name: '1-6' },
        '7-29': { name: '7-29' },
        '30-999': { name: '30+' },
      }}
      tooltipTitleSuffix="Minimum nights"
      isLoading={filteredListingsDashboard.loading}
      data={filteredListingsDashboard.data?.minNightRange}
      metricTabs={['occupancyRate']}
      color={COLOR_TERTIARY_1_600}
      currency={currency}
      handleOnSampleClick={handleOnSampleClick}
      isDisabled={isDisabled}
      maxBarSize={13}
      isGraphSizeSmall={true}
      xAxisTitle={'nights'}
      tooltipText={
        'See how the properties with different minimum nights impact their occupancy rate.'
      }
      isGraphLocked={isDisabled}
    />
  );

  const CapacityFilterCardSingleBar = (
    <SingleBarFilterCard
      title="Capacity"
      catagoryMap={'dynamicRange'}
      tooltipTitleSuffix="Guests"
      isLoading={filteredListingsDashboard.loading}
      data={filteredListingsDashboard.data?.capacity}
      metricTabs={['supply']}
      color={COLOR_PRIMARY}
      currency={currency}
      defaultMetrics="supply"
      handleOnSampleClick={handleOnSampleClick}
      tooltipText={'Capacity is the number of guests a property can accept.'}
      isGraphSizeSmall={true}
      maxBarSize={13}
      isGraphLocked={false}
      isDisabled={isDisabled}
    />
  );

  const ActiveDaysFilterCardSingleBar = (
    <SingleBarFilterCard
      title="Days Available"
      catagoryMap={{
        '1-90': { name: '1-90' },
        '91-180': { name: '91-180' },
        '181-270': { name: '181-270' },
        '271-367': { name: '271-365' },
      }}
      tooltipTitleSuffix="days"
      isLoading={filteredListingsDashboard.loading && isUserAllowed}
      data={filteredListingsDashboard.data?.daysAvailable}
      metricTabs={['supply']}
      color={COLOR_SECONDARY_2_700}
      currency={currency}
      defaultMetrics="supply"
      handleOnSampleClick={handleOnSampleClick}
      maxBarSize={13}
      isGraphSizeSmall={true}
      xAxisTitle={'days'}
      tooltipText={
        'Days available is the number of days an Airbnb listing was available for booking in the last 12 months.'
      }
      isGraphLocked={false}
      isDisabled={isDisabled}
    />
  );

  const ListingsPerHostFilterCardSingleBar = (
    <SingleBarFilterCard
      title="Listings per host"
      catagoryMap={{
        '1': { name: '1' },
        '2-5': { name: '2-5' },
        '6-20': { name: '6-20' },
        '21+': { name: '21+' },
      }}
      tooltipTitleSuffix="Listings"
      isLoading={filteredListingsDashboard.loading}
      data={filteredListingsDashboard.data?.listingsPerHost}
      metricTabs={['occupancyRate']}
      color={COLOR_PRIMARY}
      currency={currency}
      handleOnSampleClick={handleOnSampleClick}
      isDisabled={isDisabled}
      maxBarSize={13}
      isGraphSizeSmall={true}
      xAxisTitle={'listings'}
      tooltipText={'See how the number of listings owned by a host impacts its occupancy rate.'}
      isGraphLocked={isDisabled}
    />
  );

  const RevenuePotentialByPropertySizeCardMemoed = (
    <RevenuePotentialByPropertySizeCard
      listings={dashboardLayoutView == 'map' ? dynamicVisibleListings : staticListings}
      handleOnSampleClick={handleOnSampleClick}
      isDisabled={cachedMarketData.data ? !cachedMarketData.data.is_user_allowed : isDisabled}
      currency={currency}
      cachedData={
        isMarketCachedDataLoaded ? cachedMarketData.data?.revenue_breakdown?.bedroom : null
      }
      viewMode={dashboardLayoutView}
      isDynamicLoading={dynamicLoadingMapViewKPI || (!visibleListingIDs.length && !cachedLTMData)}
      multipleMarkersCallLoading={multipleMarkersCallLoading}
      handleDownloadCSV={handleDownloadCSV}
      noDataInMarket={noDataInMarket}
    />
  );

  const PropertySizeCardMemoed = (
    <PropertySizeCard
      listings={dashboardLayoutView == 'map' ? dynamicVisibleListings : staticListings}
      filterVal={filterVal}
      cachedData={isMarketCachedDataLoaded ? cachedMarketData.data?.supply_breakdown.bedroom : null}
      viewMode={dashboardLayoutView}
      isDynamicLoading={dynamicLoadingMapViewKPI}
      multipleMarkersCallLoading={multipleMarkersCallLoading}
      noDataInMarket={noDataInMarket}
    />
  );

  const PropertyTypeChannelCancelationPolicyPieChat = (
    <PropertyTypeChannelPieChart
      listings={dashboardLayoutView == 'map' ? dynamicVisibleListings : staticListings}
      otaListings={visibleOTAListings}
      cachedData={
        isMarketCachedDataLoaded
          ? {
              property_type: cachedMarketData.data?.supply_breakdown.property_type,
              cancellation_policy: cachedMarketData.data?.supply_breakdown.cancellation_policy,
              channel_type: cachedMarketData.data?.supply_breakdown.channel,
            }
          : null
      }
      viewMode={dashboardLayoutView}
      isDynamicLoading={dynamicLoadingMapViewKPI}
      multipleMarkersCallLoading={multipleMarkersCallLoading}
      noDataInMarket={noDataInMarket}
    />
  );

  const AmenityCardMemoed = (
    <AmenityCard
      listings={dashboardLayoutView == 'map' ? dynamicVisibleListings : staticListings}
      cachedData={isMarketCachedDataLoaded ? cachedMarketData.data?.supply_breakdown.amenity : null}
      viewMode={dashboardLayoutView}
      isDynamicLoading={dynamicLoadingMapViewKPI}
      multipleMarkersCallLoading={multipleMarkersCallLoading}
      noDataInMarket={noDataInMarket}
    />
  );

  const ExtraPricingCardMemoed = (
    <ExtraPricingCard
      listings={dashboardLayoutView == 'map' ? dynamicVisibleListings : staticListings}
      currency={currency}
      cachedData={isMarketCachedDataLoaded ? cachedMarketData.data?.extra_pricing : null}
      viewMode={dashboardLayoutView}
      isDynamicLoading={dynamicLoadingMapViewKPI}
      multipleMarkersCallLoading={multipleMarkersCallLoading}
      noDataInMarket={noDataInMarket}
    />
  );

  const TopCitiesCardMemoed = graph.loading ? (
    <LoadingCard height={150} type="bars" />
  ) : (
    <TopCitiesCard
      graph={graph}
      isDisabled={isDisabled}
      handleOnSampleClick={handleOnSampleClick}
      matches={matches}
    />
  );

  const TopCountriesCardMemoed = graph.loading ? (
    <LoadingCard height={150} type="bars" />
  ) : (
    <TopCountriesCard
      graph={graph}
      isDisabled={isDisabled}
      handleOnSampleClick={handleOnSampleClick}
      matches={matches}
    />
  );

  const GuestLanguageCardMemoed = graph.loading ? (
    <LoadingCard height={150} type="bars" />
  ) : (
    <GuestLanguageCard
      graph={graph}
      isDisabled={isDisabled}
      handleOnSampleClick={handleOnSampleClick}
      matches={matches}
    />
  );

  const InternationDomesticGuestsCardMemoed = graph.loading ? (
    <LoadingCard height={350} type="bars" />
  ) : (
    <InternationDomesticGuestsCard
      graph={graph}
      isDisabled={isDisabled}
      handleOnSampleClick={handleOnSampleClick}
    />
  );

  const HostsMemoed = noDataInMarket ? (
    <NoDataCard height={150} borderRadius={8} />
  ) : (multipleMarkersCallLoading && !staticListings.data?.length) || dynamicLoadingMapViewKPI ? (
    <LoadingCard height={150} type="bars" />
  ) : (
    <Hosts
      listings={dashboardLayoutView == 'map' ? dynamicVisibleListings : staticListings}
      currency={currency}
      isDisabled={isDisabled}
      handleOnSampleClick={handleOnSampleClick}
      multipleMarkersCallLoading={multipleMarkersCallLoading}
      search={search}
      user={user}
      matches={matches}
    />
  );

  const AllFilterButton = (
    <Grid container sx={{ marginTop: '-60px' }}>
      <Grid item xs={12}>
        <ZoomButtons size={30} setZoom={setZoom} />
      </Grid>

      <Grid item xs={12}>
        <Button
          className="mapFilterButton"
          size="small"
          onClick={() => toggleDrawer()}
          sx={{ fontSize: '16', background: '#fff', color: COLOR_PRIMARY_DARK }}
        >
          <FilterAltOutlinedIcon sx={{ fontSize: 18, color: 'inherit' }} />
          All Filters
        </Button>
      </Grid>
    </Grid>
  );

  const BackToDashboardButton = (
    <Button
      className="mapFilterButton"
      size="small"
      onClick={() => setDashboardLayoutView('dashboard')}
      sx={{ fontSize: '16', background: COLOR_PRIMARY_DARK, color: '#fff', minWidth: '100px' }}
    >
      Dashboard
      <ArrowRightAltRoundedIcon sx={{ fontSize: 18, color: 'inherit' }} />
    </Button>
  );

  const DynamicDataUpdateButton = () => {
    return (
      <Button
        sx={{
          backgroundColor: COLOR_PRIMARY_2,
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.35)',
          color: COLOR_WHITE,
          borderRadius: 50,
          paddingLeft: 3,
          paddingRight: 3,
          paddingTop: 2,
          paddingBottom: 2,
          ':hover': {
            backgroundColor: COLOR_PRIMARY_1,
            color: COLOR_WHITE,
          },
          fontSize: 18,
        }}
        onClick={syncDynamicListingsWithVisibleListings}
      >
        <RefreshIcon sx={{ marginRight: 1, fontSize: 28 }} /> Fetch data For Visible Map Area
      </Button>
    );
  };

  const StatisticBox = ({
    label,
    value,
    change,
    conversionFunction,
    hideKPI,
    title,
    content,
    contentAdditional,
    contentAdditional2,
  }) => (
    <Box style={{ flexBasis: '24%', height: 'auto', overflow: 'hidden' }}>
      <Box
        sx={{
          height: '50px',
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          color: '#000',
          padding: '3px 10px',
        }}
      >
        <Typography
          sx={{
            fontWeight: '500',
            fontSize: '14px',
            maxWidth: '70%',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
          }}
        >
          {label}
        </Typography>
        <ClickAwayListener
          onClickAway={() => setIsMapViewMainKpiCardTooltipOpen([false, false, false, false])}
        >
          <InfoTooltip
            title={
              <TooltipCard
                title={title}
                content={content}
                contentAdditional={contentAdditional}
                contentAdditional2={contentAdditional2}
                link=""
              />
            }
            enterTouchDelay={0}
            leaveTouchDelay={3000}
            open={isMapViewMainKpiCardTooltipOpen[MAP_VIEW_TOOLTIP_MAPPING[title]]}
            onOpen={() =>
              setIsMapViewMainKpiCardTooltipOpen(prev => [
                ...prev.slice(0, MAP_VIEW_TOOLTIP_MAPPING[title]),
                true,
                ...prev.slice(MAP_VIEW_TOOLTIP_MAPPING[title] + 1),
              ])
            }
            onClose={() =>
              setIsMapViewMainKpiCardTooltipOpen(prev => [
                ...prev.slice(0, MAP_VIEW_TOOLTIP_MAPPING[title]),
                false,
                ...prev.slice(MAP_VIEW_TOOLTIP_MAPPING[title] + 1),
              ])
            }
          >
            <IconButton
              style={{ padding: '2px' }}
              onClick={() =>
                setIsMapViewMainKpiCardTooltipOpen(prev => {
                  const newState = [...prev];
                  newState[MAP_VIEW_TOOLTIP_MAPPING[title]] = !newState[
                    MAP_VIEW_TOOLTIP_MAPPING[title]
                  ];
                  return newState;
                })
              }
            >
              <InfoOutlinedIcon sx={{ fontSize: '14px', color: '#4aa59a' }} />
            </IconButton>
          </InfoTooltip>
        </ClickAwayListener>
      </Box>
      <Box
        sx={{
          height: '40%',
          width: '100%',
          color: '#000',
          padding: '0px 10px',
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: '1000',
            color: KPI_CARD_COLOR,
          }}
        >
          {hideKPI ? (
            <LockSharpIcon
              onClick={handleOnSampleClick}
              style={{ color: COLOR_PRIMARY, fontSize: '30px', cursor: 'pointer' }}
            />
          ) : (
            conversionFunction(value)
          )}
        </Typography>
      </Box>
    </Box>
  );

  const MainKpiMapView = noDataInMarket ? (
    <NoDataCard height={120} borderRadius={8} />
  ) : dynamicLoadingMapViewKPI || (!visibleListingIDs.length && multipleMarkersCallLoading) ? (
    <Grid container item>
      <LoadingCard height={60} type="bars" barCount={1} />
    </Grid>
  ) : (
    <Box
      sx={{
        height: '120px',
        width: '100%',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
      }}
    >
      {/* Occupancy */}
      <StatisticBox
        label={'Occupancy Rate'}
        value={marketLevelOccupancyRate == -1 ? '_' : marketLevelOccupancyRate}
        change={occupancyYoYChange}
        conversionFunction={value => `${value} %`}
        hideKPI={!showPremiumDataDynamic}
        title={'Occupancy (Median)'}
        content={'How often was a typical active property occupied over the last 12 months?'}
        contentAdditional={''}
        contentAdditional2={''}
      />
      {/* Revenue */}
      <StatisticBox
        label={'Revenue'}
        value={marketLevelRevenuePotential == -1 ? '_' : marketLevelRevenuePotential}
        change={revenueYoYChange}
        conversionFunction={value =>
          `${currency && exchangeRates[currency].symbol}${formatCurrency(
            String(convertCurrency(currency, value))
          )}`
        }
        hideKPI={!showPremiumDataDynamic}
        title={'Revenue'}
        content={
          'What’s the median revenue a property in this market generated over the last 12 months?'
        }
        contentAdditional={''}
        contentAdditional2={
          'This Revenue figure represents the median over the past 12 months and does not include taxes, service fees, or additional guest fees.'
        }
      />
      {/* Nightly Rate */}
      <StatisticBox
        label="Nightly Rate"
        value={marketLevelDailyRate == -1 ? '_' : marketLevelDailyRate}
        change={dailyYoYChange}
        conversionFunction={value =>
          `${currency && exchangeRates[currency].symbol}${formatCurrency(
            String(convertCurrency(currency, value))
          )}`
        }
        hideKPI={false}
        title={'Nightly Rate (Median)'}
        content={'How much did hosts in this market charge per day over the last 12 months?'}
        contentAdditional={''}
        contentAdditional2={''}
      />
      {/* Active Listing */}
      <StatisticBox
        label="Listings"
        value={marketLevelActiveListings}
        change={listingYoYChange}
        conversionFunction={value => formatCurrency(value.toString())}
        hideKPI={false}
        title={'Listings'}
        content={'Listings is the total active listings over the past 12 months.'}
        contentAdditional={''}
        contentAdditional2={''}
      />
    </Box>
  );

  const ListingCardGrid = useMemo(
    () => (
      <Grid
        item
        container
        spacing={1}
        justifyContent={'center'}
        xs={12}
        sx={{
          position: 'relative',
          height: '440px',
          overflow: 'auto',
          overflowX: 'clip',
          marginTop: '0px',
          paddingBottom: '10px',
          marginBottom: '10px',
        }}
      >
        {noDataInMarket ? (
          <NoDataCard height={150} borderRadius={8} />
        ) : dynamicLoadingMapViewKPI ||
          (!dynamicVisibleListings.data.length && multipleMarkersCallLoading) ? (
          <Grid container item>
            <LoadingCard height={200} type="bars" />
          </Grid>
        ) : (
          sortListingBasedOnKey(dynamicVisibleListings.data, listingSortingKey)
            .slice(listingsGridStartIndexOffset * 9, listingsGridStartIndexOffset * 9 + 9)
            .map(data => {
              return (
                <Grid
                  container
                  item
                  xs={12}
                  md={6}
                  lg={4}
                  xl={4}
                  onMouseEnter={() => {
                    if (search.data.name)
                      updateDynamoDBForUserVerification(
                        search.data.name,
                        setSubscriptionModalOpen,
                        user
                      );
                  }}
                >
                  <SimplifiedAirbnbPointerBody
                    data={data}
                    currency={currency}
                    canDelete={false}
                    isDisabled={isDisabled}
                    deleteListing={() => {}}
                    setOpenFullView={() => {}}
                    isHidden={false}
                    isEstimator={false}
                    setTopPerformingListingOnFocus={setTopPerformingListingOnFocus}
                    setTopPerformingListingModalOpen={setTopPerformingListingModalOpen}
                    handleOnSampleClick={handleOnSampleClick}
                    isListingRecentlyAdded={data.annualRevenueLTM == 'N/A'}
                  />
                </Grid>
              );
            })
        )}
        <Grid container item xs={12} justifyContent="center" alignItems="flex-end">
          <Grid item>
            <Pagination
              page={listingsGridStartIndexOffset + 1}
              count={Math.ceil(visibleListingIDs.length / 9)}
              variant="outlined"
              onChange={(event, value) => setListingsGridStartIndexOffset(value - 1)}
            />
          </Grid>
        </Grid>
      </Grid>
    ),
    [
      dynamicVisibleListings,
      listingsGridStartIndexOffset,
      listingSortingKey,
      dynamicLoadingMapViewKPI,
    ]
  );

  const getSubSectionHeading = (
    title: string | JSX.Element,
    id: string,
    showDownloadButton: boolean = false,
    downloadKey?: any,
    tooltipText?: string,
    filterButton?: JSX.Element
  ) => {
    return (
      <Grid
        container
        item
        xs={12}
        id={id}
        sx={{
          margin: '10px 10px',
          marginLeft: 0,
          padding: '10px auto',
          fontSize: '20px',
          fontWeight: 'bold',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <Typography variant="h5" className="marketTitle" sx={{ fontSize: 'inherit' }}>
          {title}{' '}
          {tooltipText && (
            <InfoTooltip
              enterTouchDelay={0}
              leaveTouchDelay={30000}
              title={
                <Card>
                  <CardContent style={{ background: COLOR_TOOLTIP_BACKGROUND }}>
                    <Typography variant="body1" style={{ fontWeight: 500 }}>
                      {tooltipText}
                    </Typography>
                  </CardContent>
                </Card>
              }
              style={{ cursor: 'pointer' }}
            >
              <IconButton style={infoIconButton}>
                <InfoOutlinedIcon style={infoIconStyle} />
              </IconButton>
            </InfoTooltip>
          )}
        </Typography>
        {filterButton && filterButton}
      </Grid>
    );
  };

  const ActiveListingCountHeader = getSubSectionHeading(
    <Box sx={{ display: 'flex' }}>
      <span style={{ color: COLOR_PRIMARY, marginRight: '5px' }}>
        {noDataInMarket ? (
          '0'
        ) : multipleMarkersCallLoading && !dynamicVisibleListings.data.length ? (
          <CircularProgress size={20} />
        ) : (
          formatCurrency(dynamicVisibleListings.data.length + '')
        )}
      </span>{' '}
      listings: {search.data ? search.data.name : ''}
      <Box sx={{ cursor: 'pointer', marginLeft: '5px' }}>
        <ExportButtonOptionTooltip
          body={
            <Typography variant="body2" style={{ fontWeight: 400 }}>
              {/* <span style={{ fontWeight: 'bold' }}>Pro feature - Coming Soon!</span>
              <br />
              <br />
              Download all the listings data for this market.
              <br /> */}
              <br />
              <span style={{ fontWeight: 'bold' }}>
                Download Individual Listing Level Data in CSV format.
              </span>
            </Typography>
          }
        >
          <Box
            onClick={() => {
              // handleDownloadCSV(DOWNLOAD_CSV_LISTINGS_LTM_DATA);
              setShowIndividualListingFormModal(true);
            }}
            sx={{
              width: '100%',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              fontWeight: 'bold',
            }}
          >
            {multipleMarkersCallLoading ? (
              <CircularProgress size={20} sx={{ color: COLOR_PRIMARY_DARK }} />
            ) : (
              <DownloadIcon style={{ color: COLOR_PRIMARY_DARK }} />
            )}
          </Box>
        </ExportButtonOptionTooltip>
      </Box>
    </Box>,
    'active-listing-heading',
    false,
    null,
    '', //TODO add tooltip here
    <>
      <Box>
        <FormControl>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={listingSortingKey}
            label=""
            onChange={e => {
              isUserAllowed && setListingSortingKey(e.target.value);
              !isUserAllowed && handleOnSampleClick();
            }}
            sx={{
              '& .MuiSelect-select': {
                padding: '4px 0px 4px 10px',
              },
              marginRight: '10px',
            }}
          >
            <MenuItem value={'performance'}>Top properties</MenuItem>
            <MenuItem value={'review'}>
              Review Count{' '}
              {!isUserAllowed && (
                <LockSharpIcon style={{ fontSize: 18, color: 'inherit', marginLeft: '5px' }} />
              )}
            </MenuItem>
            <MenuItem value={'revenue'}>
              Revenue{' '}
              {!isUserAllowed && (
                <LockSharpIcon style={{ fontSize: 18, color: 'inherit', marginLeft: '5px' }} />
              )}
            </MenuItem>
            <MenuItem value={'occupancy'}>
              Occupancy{' '}
              {!isUserAllowed && (
                <LockSharpIcon style={{ fontSize: 18, color: 'inherit', marginLeft: '5px' }} />
              )}
            </MenuItem>
            <MenuItem value={'adr'}>
              Daily Rate{' '}
              {!isUserAllowed && (
                <LockSharpIcon style={{ fontSize: 18, color: 'inherit', marginLeft: '5px' }} />
              )}
            </MenuItem>
          </Select>
        </FormControl>
        <Button
          className="mapFilterButton"
          size="small"
          onClick={() => toggleDrawer()}
          sx={{
            fontSize: '16',
            background: COLOR_PRIMARY_1,
            color: '#ffffff',
            '&:hover': { backgroundColor: COLOR_PRIMARY_1 },
          }}
        >
          <FilterAltOutlinedIcon sx={{ fontSize: 18, color: 'inherit' }} />
          All Filters
        </Button>
      </Box>
    </>
  );

  const isFullScreenLoadingOn = cachedMarketData.loading && !visibleListingIDs.length;

  return (
    <>
      <DiscoveryAlertModal />
      <IndividualListingFormModal />
      <Grid
        container
        direction="row"
        className="dashboard__overview"
        xs={12}
        sx={matches ? { top: '-15px' } : {}}
      >
        <Grid
          container
          alignItems={'flex-start'}
          sx={{ width: mapWidth + '%', overflow: 'hidden' }}
          className="leftView"
          id="overviewLeft"
        >
          <Paper id="map" className="mapWrapper">
            {(dashboardLayoutView === 'map' || dashboardLayoutView === 'dashboard') &&
              multipleMarkersCallLoading && (
                <Box className="mapLoader__wrapper">
                  <LinearProgress className="linearProgressbar" color="inherit" />
                </Box>
              )}
            {!search.loading && mapWidth !== 0 && (
              <>
                <Map
                  matches={matches}
                  dashboardLayoutView={dashboardLayoutView}
                  setDashboardLayoutView={setDashboardLayoutView}
                  zoom={zoom}
                  setZoom={setZoom}
                  bounds={bounds}
                  search={search}
                  setBounds={setBounds}
                  setSearchLimitAlertBox={setSearchLimitAlertBox}
                  setDynamicTrigger={setDynamicTrigger}
                  setIsDynamicDataBtnVisible={setIsDynamicDataBtnVisible}
                  listings={listings}
                  setListings={setListings}
                  visibleListings={visibleListings}
                  visibleListingIDs={visibleListingIDs}
                  otaListings={otaListings}
                  setOTAListings={setOTAListings}
                  multipleBookingMarkersCallLoading={multipleBookingMarkersCallLoading}
                  isDisabled={isDisabled}
                  isUserAllowed={isUserAllowed}
                  revPotentialRangeInvestment={revPotentialRangeInvestment}
                  subscriptionModalOpen={subscriptionModalOpen}
                  currency={currency}
                  filteredListings={filteredListings}
                  filteredOTAListings={filteredOTAListings}
                  visibleOTAListings={visibleOTAListings}
                  visibleOTAListingIDs={visibleOTAListingIDs}
                  multipleMarkersCallLoading={multipleMarkersCallLoading}
                  setSubscriptionModalOpen={setSubscriptionModalOpen}
                  user={user}
                  isLoggedIn={isLoggedIn}
                  setLoginModalOpen={setLoginModalOpen}
                  setShowSearchCreditDeductWarningModal={setShowSearchCreditDeductWarningModal}
                  handleOnSampleClick={handleOnSampleClick}
                  applyFilter={applyFilter}
                  filterActive={filterActive}
                  setShowPremiumDataDynamic={setShowPremiumDataDynamic}
                  toggleDrawer={toggleDrawer}
                  setFilterVal={setFilterVal}
                  filterVal={filterVal}
                  setFilterActive={setFilterActive}
                  noDataInMarket={noDataInMarket}
                  topPerformingListingOnFocus={topPerformingListingOnFocus}
                  showNeighbourhood={showNeighbourhood}
                  setShowNeighbourhood={setShowNeighbourhood}
                  setListingsGridStartIndexOffset={setListingsGridStartIndexOffset}
                  dummyMarketData={allMarketProcessedData ? allMarketProcessedData : []}
                  discoveryMarkets={discoveryMarkets}
                  filteredDiscoveryMarkets={filteredDiscoveryMarketsSet}
                  setDiscoveryMarkets={setDiscoveryMarkets}
                  topPerformingMarketOnFocus={topPerformingMarketOnFocus}
                  setTopPerformingMarketOnFocus={setTopPerformingMarketOnFocus}
                  marketsToCompareList={marketsToCompareList}
                  setMarketsToCompareList={setMarketsToCompareList}
                  minROI={minROI}
                  maxROI={maxROI}
                  isMarketDataAccessible={isMarketDataAccessible}
                  freeMarketDataKey={freeMarketDataKey}
                  isDiscoveryMapViewOpen={isDiscoveryMapViewOpen}
                  setIsDiscoveryMapViewOpen={setIsDiscoveryMapViewOpen}
                  isTabChanging={isTabChanging}
                  selectedDiscoveryCountry={selectedDiscoveryCountry}
                  allRawMarketData={allRawMarketData}
                  setSelectedDiscoveryCountry={setSelectedDiscoveryCountry}
                  mapWidth={mapWidth}
                />
                {dashboardLayoutView !== 'compare' &&
                  !(dashboardLayoutView == 'discovery' && matches) && (
                    <Button
                      variant="contained"
                      className="mapToggleBtn"
                      size="small"
                      onClick={() => {
                        if (mapWidth == 20 && dashboardLayoutView !== 'discovery') {
                          setMapWidth(getSelectedViewWidth('map', matches, false));
                          setDashboardLayoutView('map');
                        } else if (mapWidth == 20 && dashboardLayoutView === 'discovery') {
                          setMapWidth(getSelectedViewWidth('discovery', matches, true));
                          setDashboardLayoutView('discovery');
                        } else if (mapWidth == 100 && dashboardLayoutView === 'discovery') {
                          setMapWidth(getSelectedViewWidth('discovery', matches, false));
                          setDashboardLayoutView('discovery');
                        } else if (mapWidth == MAP_SIZE_MAP_VIEW_DESKTOP || mapWidth == 100) {
                          setMapWidth(getSelectedViewWidth('dashboard', matches, false));
                          setDashboardLayoutView('dashboard');
                        }
                        handleOnClickTabLoading();
                      }}
                    >
                      <ArrowRightRoundedIcon
                        className={`mapToggleBtn__icon ${
                          dashboardLayoutView === 'map' || mapWidth >= MAP_SIZE_MAP_VIEW_DESKTOP
                            ? 'mapToggleBtn__icon--active'
                            : ''
                        }`}
                      />
                    </Button>
                  )}

                {dashboardLayoutView === 'map' && matches && (
                  <BottomDrawer
                    topComponents={[AllFilterButton, BackToDashboardButton]}
                    components={[
                      getSubSectionHeading(
                        `Map Area Overview: ${search.data.name}`,
                        'dashboard-overview-heading'
                      ),
                      MainKpiMapView,
                      ActiveListingCountHeader,
                      ListingCardGrid,
                      getSubSectionHeading('Revenue', 'map-mobile-revenue-tab'),
                      RevenuePotentialByPropertySizeCardMemoed,
                      getSubSectionHeading('Supply', 'map-mobile-supply-tab'),
                      PropertySizeCardMemoed,
                      PropertyTypeChannelCancelationPolicyPieChat,
                      AmenityCardMemoed,
                      getSubSectionHeading('Hosts', 'map-mobile-host-tab'),
                      HostsMemoed,
                      <Box sx={{ marginBottom: '50px' }} />,
                    ]}
                    isOverLayVisible={isDynamicDataBtnVisible}
                    overlayButton={<DynamicDataUpdateButton />}
                  />
                )}

                {dashboardLayoutView === 'discovery' && matches && (
                  <BottomDiscoveryDrawer
                    discoveryMarkets={allMarketProcessedData ? allMarketProcessedData : []}
                    setTopPerformingMarketOnFocus={setTopPerformingMarketOnFocus}
                    marketsToCompareList={marketsToCompareList}
                    setMarketsToCompareList={setMarketsToCompareList}
                    setDashboardLayoutView={setDashboardLayoutView}
                    minROI={minROI}
                    maxROI={maxROI}
                    isMarketDataAccessible={isMarketDataAccessible}
                    freeMarketDataKey={freeMarketDataKey}
                    currency={currency}
                    mapWidth={mapWidth}
                    setMapWidth={setMapWidth}
                    isDiscoveryMapViewOpen={isDiscoveryMapViewOpen}
                    setIsDiscoveryMapViewOpen={setIsDiscoveryMapViewOpen}
                    handleOnSampleClick={handleOnSampleClick}
                    discoveryMarketType={discoveryMarketType}
                    setDiscoveryMarketType={setDiscoveryMarketType}
                    allRawMarketData={allRawMarketData}
                    discoverTabData={discoverTabData}
                    setDiscoveryTabData={setDiscoveryTabData}
                    selectedDiscoveryCountry={selectedDiscoveryCountry}
                    setSelectedDiscoveryCountry={setSelectedDiscoveryCountry}
                    isDiscoveryMarketLoading={isDiscoveryMarketLoading}
                  />
                )}
              </>
            )}
          </Paper>
        </Grid>
        <Grid
          container
          sx={{ width: 100 - mapWidth + '%' }}
          className="rightView"
          id="overviewRight"
        >
          <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            direction={'row'}
            xs={12}
            spacing={1}
            className="rightView__container"
            sx={{ padding: matches ? 0 : '20px', paddingRight: 0 }}
          >
            <Grid item xs={12} sx={{ position: 'sticky' }}>
              <DashboardNavbar
                overviewDashboardTabs={overviewDashboardTabs}
                dashboardLayoutView={dashboardLayoutView}
              />
            </Grid>

            {!isTabChanging && dashboardLayoutView === 'map' && !matches && (
              <Grid container item xs={12} sx={{ position: 'relative' }}>
                {isDynamicDataBtnVisible && (
                  <Box
                    sx={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '3400px',
                      backgroundColor: 'rgba(255, 255, 255, 0.8)',
                      zIndex: theme => theme.zIndex.modal - 1,
                    }}
                  >
                    <div
                      style={{
                        position: 'sticky',
                        top: '40%',
                        display: 'flex',
                        justifyContent: 'center',
                      }}
                    >
                      <DynamicDataUpdateButton />
                    </div>
                  </Box>
                )}

                {getMapViewHeadings('Map Area Overview', search.data ? search.data.name : '')}

                <Grid
                  container
                  item
                  sx={{
                    height: '120px',
                    width: '100%',
                    marginBottom: '10px',
                    padding: '5px',
                    boxShadow: '0 4px 10px #0002',
                    borderRadius: '8px',
                  }}
                >
                  {MainKpiMapView}
                </Grid>

                {ActiveListingCountHeader}
                <Grid
                  container
                  item
                  sx={{
                    marginBottom: '10px',
                    borderRadius: '8px',
                    paddingTop: '10px',
                  }}
                >
                  {ListingCardGrid}
                </Grid>

                <Grid
                  item
                  container
                  xs={12}
                  ref={subKPIcontainerMapViewRef}
                  sx={{ background: '#fff' }}
                >
                  <SubKpiNavbarMap
                    stickyWidth={100 - mapWidth + '% !important'}
                    marketName={search.data ? search.data.name : ''}
                    containerRef={subKPIcontainerMapViewRef}
                    dashboardScrollPositionTop={dashboardScrollPositionTop}
                    subKpiMetaData={subKpiTabsMapViewMetadata}
                    subKpiSelected={subKpiMapViewSelected}
                    overviewDashboardTabs={overviewDashboardTabs}
                    dashboardLayoutView={dashboardLayoutView}
                  />
                </Grid>
                <Grid item container></Grid>
                <Grid
                  item
                  sx={{
                    width: '100%',
                    margin: '0px 0px',
                    padding: '5px 3px 5px 10px',
                  }}
                >
                  {getSubSectionHeading('Revenue', 'map-revenue-tab')}
                  {RevenuePotentialByPropertySizeCardMemoed}
                  {getSubSectionHeading('Supply', 'map-supply-tab')}
                  {PropertySizeCardMemoed}
                  {PropertyTypeChannelCancelationPolicyPieChat}
                  {AmenityCardMemoed}
                  {getSubSectionHeading('ADR', 'map-adr-tab')}
                  {ExtraPricingCardMemoed}

                  {getSubSectionHeading('Hosts', 'map-host-tab')}
                  <Box
                    sx={{
                      boxShadow: '0 4px 10px #0002',
                      borderRadius: '8px',
                      margin: '10px 0px',
                      padding: '15px',
                    }}
                  >
                    {HostsMemoed}
                  </Box>
                </Grid>
              </Grid>
            )}

            {isTabChanging && dashboardLoadingScreenFullSize}

            {dashboardLayoutView === 'dashboard' && !isTabChanging && (
              <Grid container xs={12}>
                <Grid item xs={12} className="section--spacing">
                  <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                    <Typography variant="h5" className="marketTitle">
                      Market Overview: <span>{search.data.name}</span>
                    </Typography>
                  </Box>
                </Grid>

                {/* Main KPI */}
                <Grid item xs={12} className="section--spacing">
                  {MainKPICardMemoed}
                </Grid>

                <Grid item xs={12} className="section--spacing">
                  <Typography variant="h5" className="marketTitle">
                    Market Details: <span>{search.data.name}</span>
                  </Typography>
                </Grid>

                <Grid
                  item
                  container
                  xs={12}
                  ref={subKPIcontainerRef}
                  className="section--spacing"
                  style={{ marginLeft: matches ? 0 : '20px' }}
                >
                  <SubKpiNavbar
                    marketName={search.data?.name}
                    subKpiMetaData={subKpiTabsMetadata}
                    subKpiSelected={subKpiSelected}
                    dashboardScrollPositionTop={dashboardScrollPositionTop}
                    containerRef={subKPIcontainerRef}
                    dashboardLayoutView={dashboardLayoutView}
                    overviewDashboardTabs={overviewDashboardTabs}
                  />
                </Grid>

                <Grid
                  container
                  item
                  xs={12}
                  className="section--spacing"
                  id="overview-tab"
                  sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
                >
                  <Typography variant="h5" className="marketTitle">
                    Overview
                  </Typography>
                  <Divider />
                </Grid>

                <Grid
                  container
                  alignItems={'flex-start'}
                  item
                  xs={12}
                  className="section--spacing"
                  spacing={2}
                >
                  <Grid item container xs={12} md={6} className="subSection--spacing">
                    {PropertySizeFilterCardSingleBar}
                  </Grid>
                  <Grid item container xs={12} md={6} className="subSection--spacing">
                    {PropertyTypeFilterCardSingleBar}
                  </Grid>
                  <Grid item container xs={12} sm={6} className="subSection--spacing">
                    {BathroomNumberFilterCardSingleBar}
                  </Grid>
                  <Grid item container xs={12} sm={6} className="subSection--spacing">
                    {AdrRangeFilterCardSingleBar}
                  </Grid>
                  <Grid item container xs={12} sm={6} className="subSection--spacing">
                    {RatingRangeFilterCardSingleBar}
                  </Grid>
                  <Grid item container xs={12} sm={6} className="subSection--spacing">
                    {ListingsPerHostFilterCardSingleBar}
                  </Grid>
                  <Grid item container xs={12} sm={6} className="subSection--spacing">
                    {MinNightRangeFilterCardSingleBar}
                  </Grid>
                </Grid>

                <Grid container item xs={12} className="section--spacing" id="supply-tab">
                  <Typography variant="h5" className="marketTitle" id="supply-tab">
                    Supply
                  </Typography>
                </Grid>

                <Grid
                  container
                  item
                  xs={12}
                  justifyContent={'space-between'}
                  alignItems={'flex-start'}
                  className="section--spacing"
                  spacing={2}
                >
                  <Grid item container xs={matches ? 12 : 6}>
                    <Grid item container className="subSection--spacing">
                      {PropertySizeCardMemoed}
                    </Grid>
                    <Grid item container className="subSection--spacing">
                      {AmenityCardMemoed}
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    container
                    xs={matches ? 12 : 6}
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                  >
                    {PropertyTypeChannelCancelationPolicyPieChat}
                  </Grid>
                  <Grid item container xs={12} sm={6} className="subSection--spacing">
                    {CapacityFilterCardSingleBar}
                  </Grid>
                  <Grid item container xs={12} sm={6} className="subSection--spacing">
                    {ActiveDaysFilterCardSingleBar}
                  </Grid>
                </Grid>

                <Grid container item xs={12} className="section--spacing" id="adr-tab">
                  <Typography variant="h5" className="marketTitle">
                    Average Daily Rate
                  </Typography>
                </Grid>

                <Grid
                  container
                  item
                  xs={12}
                  justifyContent={'flex-start'}
                  alignItems={'flex-start'}
                  className="section--spacing"
                  spacing={1}
                >
                  <Grid
                    item
                    container
                    xs={matches ? 12 : 6}
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    className="subSection--spacing"
                  >
                    {ExtraPricingCardMemoed}
                  </Grid>
                </Grid>

                <Grid container item xs={12} className="section--spacing" id="occupancy-tab">
                  <Typography variant="h5" className="marketTitle">
                    Occupancy Rate
                  </Typography>
                </Grid>

                <Grid
                  container
                  item
                  xs={12}
                  justifyContent={'flex-start'}
                  alignItems={'flex-start'}
                  className="section--spacing"
                  spacing={1}
                >
                  <Grid
                    item
                    container
                    xs={12}
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                  >
                    {InternationDomesticGuestsCardMemoed}
                  </Grid>

                  <Grid
                    item
                    container
                    direction={'row'}
                    xs={12}
                    spacing={2}
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                  >
                    <Grid
                      item
                      xs={matches ? 12 : 4}
                      sx={{ marginBottom: 2 }}
                      className="subSection--spacing"
                    >
                      {TopCitiesCardMemoed}
                    </Grid>

                    <Grid item xs={matches ? 12 : 4} className="subSection--spacing">
                      {TopCountriesCardMemoed}
                    </Grid>

                    <Grid item xs={matches ? 12 : 4} className="subSection--spacing">
                      {GuestLanguageCardMemoed}
                    </Grid>
                  </Grid>
                </Grid>

                <Grid container item xs={12} className="section--spacing" id="host-tab">
                  <Typography variant="h5" className="marketTitle">
                    Hosts
                  </Typography>
                </Grid>

                <Grid
                  container
                  item
                  xs={12}
                  justifyContent={'flex-start'}
                  alignItems={'flex-start'}
                  className="section--spacing"
                  spacing={1}
                >
                  <Grid item className="subSection--spacing" sx={{ width: '100%' }}>
                    {HostsMemoed}
                  </Grid>
                </Grid>
              </Grid>
            )}

            {dashboardLayoutView === 'discovery' &&
              !isTabChanging &&
              discoveryMarkets &&
              !user.showDiscoveryAI && (
                <DiscoveryTab
                  discoveryMarkets={processedMarketData ? processedMarketData : []}
                  setTopPerformingMarketOnFocus={setTopPerformingMarketOnFocus}
                  marketsToCompareList={marketsToCompareList}
                  setMarketsToCompareList={setMarketsToCompareList}
                  setDashboardLayoutView={setDashboardLayoutView}
                  // minROI={minROI}
                  // maxROI={maxROI}
                  isMarketDataAccessible={isMarketDataAccessible}
                  freeMarketDataKey={freeMarketDataKey}
                  currency={currency}
                  mapWidth={mapWidth}
                  setMapWidth={setMapWidth}
                  isDiscoveryMapViewOpen={isDiscoveryMapViewOpen}
                  setIsDiscoveryMapViewOpen={setIsDiscoveryMapViewOpen}
                  handleOnSampleClick={handleOnSampleClick}
                  discoveryMarketType={discoveryMarketType}
                  setDiscoveryMarketType={setDiscoveryMarketType}
                  allRawMarketData={allRawMarketData}
                  discoverTabData={discoverTabData}
                  setDiscoveryTabData={setDiscoveryTabData}
                  selectedDiscoveryCountry={selectedDiscoveryCountry}
                  setSelectedDiscoveryCountry={setSelectedDiscoveryCountry}
                  isDiscoveryMarketLoading={isDiscoveryMarketLoading}
                />
              )}
            {dashboardLayoutView === 'discovery' && !isTabChanging && user.showDiscoveryAI && (
              <DiscoveryAi handleOnSampleClick={handleOnSampleClick} />
            )}

            {dashboardLayoutView === 'compare' && !isTabChanging && discoveryMarkets && (
              <CompareTab
                marketsToCompareList={marketsToCompareList}
                setMarketsToCompareList={setMarketsToCompareList}
                discoveryMarkets={discoveryMarkets ? discoveryMarkets : []}
                allMarketData={allMarketProcessedData ? allMarketProcessedData : []}
                minROI={minROI}
                maxROI={maxROI}
                isMarketDataAccessible={isMarketDataAccessible}
                freeMarketDataKey={freeMarketDataKey}
                currency={currency}
                handleOnSampleClick={handleOnSampleClick}
              />
            )}
          </Grid>
        </Grid>
      </Grid>
      {user && user.userDescription !== 'Trial' && (
        <ConfirmUnlockRegionModal
          open={!isUserAllowed && showSearchCreditDeductWarningModal}
          onConfirm={() => {
            setShowSearchCreditDeductWarningModal(false);
            getMarkers(true, 1);
          }}
          onCancel={() => setShowSearchCreditDeductWarningModal(false)}
          message="Would you like to unlock this market? (Please note this will deduct 1 market credit.)"
        />
      )}
      {extraCreditDeductModal && (
        <ConfirmUnlockRegionModal
          open={extraCreditDeductModal}
          _onClose={() => setExtraCreditDeductModal(false)}
          onConfirm={() => {
            setCreditsToBeDeducted(Math.ceil(Object.keys(listings.data).length / 10000 - 1));
            deductCredits();
            setExtraCreditDeductModal(false);
          }}
          onCancel={() => {
            exportIndividualListings(false, true);
            setExtraCreditDeductModal(false);
          }}
          message={`Please note that you can export only 10,000 listings as complementary with your current subscription. Exporting all ${
            Object.keys(listings.data).length
          } listings will deduct ${Math.ceil(
            Object.keys(listings.data).length / 10000 - 1
          )} more market credits. (For markets with greater than 10,000 listings, 1 additional market credit will be deducted for exporting each additional 10,000 listings) ${
            user.credits !== 0 && user.credits >= creditsToBeDeducted - 1
              ? ''
              : ' Add more credits.'
          }`}
          buttonNames={
            user.credits !== 0 && user.credits >= creditsToBeDeducted - 1
              ? ['Export only 10,000 listings', 'Export all listings']
              : ['Export only 10,000 listings', 'Add credits']
          }
        />
      )}

      {confirmSaveCountryPlanMarketModalOpen && (
        <ConfirmUnlockRegionModal
          open={confirmSaveCountryPlanMarketModalOpen}
          onConfirm={async () => {
            const res = await handleConfirmSaveCountryPlanMarket();
            setConfirmSaveCountryPlanMarketModalOpen(false);
            handleSaveCountryPlanMarketApiResponse(res);
          }}
          onCancel={() => setConfirmSaveCountryPlanMarketModalOpen(false)}
          message="Would you like to save this market to your search?"
          buttonNames={['Cancel', 'Save']}
          reverseButton={true}
          showLoader={true}
        />
      )}

      {topPerformingListingModalOpen && (
        <IndividualListingModal
          open={true}
          onClose={() => setTopPerformingListingModalOpen(null)}
          data={{
            ...listings.data[topPerformingListingModalOpen],
            listingID: topPerformingListingModalOpen,
          }}
          currency={currency}
          isDisabled={isDisabled}
          setSubscriptionModalOpen={setSubscriptionModalOpen}
          handleOnSampleClick={handleOnSampleClick}
          subscriptionModalOpen={subscriptionModalOpen}
          multipleBookingMarkersCallLoading={multipleBookingMarkersCallLoading}
          isEstimator={false}
        />
      )}

      {extraExportCreditsLoading && (
        <Backdrop
          sx={{ color: '#fff', zIndex: theme => theme.zIndex.drawer + 1 }}
          open={extraExportCreditsLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}

      {!isEmailVerifyModalOpen && (
        <ToastContainer position="bottom-left" newestOnTop style={{ marginTop: '40px' }} />
      )}
    </>
  );
};

const DashboardNavbar = ({
  overviewDashboardTabs,
  dashboardLayoutView,
}: {
  overviewDashboardTabs: { label: string; value: string; icon: JSX.Element; onclick: () => void }[];
  dashboardLayoutView: 'map' | 'dashboard' | 'discovery' | 'compare';
}) => {
  const renderTabLabelCondition = () => {
    return dashboardLayoutView !== 'map';
  };

  return (
    <>
      <TabBar
        tabList={overviewDashboardTabs}
        currentTab={dashboardLayoutView}
        color={COLOR_PRIMARY_2}
        renderLabelCondition={renderTabLabelCondition}
      />
    </>
  );
};

const SubKpiNavbarMap = ({
  marketName,
  stickyWidth,
  subKpiMetaData,
  subKpiSelected,
  dashboardScrollPositionTop,
  containerRef,
  dashboardLayoutView,
  overviewDashboardTabs,
}) => {
  const [isSticky, setIsSticky] = useState<boolean>(false);

  useEffect(() => {
    const rect = containerRef.current?.getBoundingClientRect();

    if (rect && (rect as DOMRect).top < 78) {
      setIsSticky(true);
    } else {
      setIsSticky(false);
    }
  }, [dashboardScrollPositionTop]);

  return (
    <Box
      sx={{
        width: isSticky ? stickyWidth : '100%',
        background: '#fff',
        paddingRight: '5px',
        position: isSticky ? 'absolute' : 'static',
        top: isSticky ? 0 : 'auto',
        zIndex: isSticky ? 1099 : 'auto',
        marginLeft: isSticky ? '-10px' : '0px',
      }}
    >
      <Box sx={{ paddingTop: '12px', marginBottom: '-12px' }}>
        {getMapViewHeadings('Map Area Details', marketName)}
      </Box>
      {isSticky && (
        <DashboardNavbar
          overviewDashboardTabs={overviewDashboardTabs}
          dashboardLayoutView={dashboardLayoutView}
        />
      )}
      <TabBar
        tabList={subKpiMetaData}
        currentTab={subKpiSelected}
        color={COLOR_PRIMARY_2}
        renderLabelCondition={() => true}
      />
    </Box>
  );
};

const SubKpiNavbar = ({
  marketName,
  subKpiMetaData,
  subKpiSelected,
  dashboardScrollPositionTop,
  containerRef,
  dashboardLayoutView,
  overviewDashboardTabs,
}) => {
  const [isSticky, setIsSticky] = useState<boolean>(false);

  useEffect(() => {
    const rect = containerRef.current?.getBoundingClientRect();

    if (rect && (rect as DOMRect).top < 78) {
      setIsSticky(true);
    } else {
      setIsSticky(false);
    }
  }, [dashboardScrollPositionTop]);

  return (
    <Box className={`subKpiTabConntainer ${isSticky ? 'subKpiTabConntainer--sticky' : ''}`}>
      {isSticky && (
        <Box sx={{ background: '#fff', fontSize: '18px' }}>
          <Typography
            variant="h5"
            className="marketTitle"
            sx={{
              color: '#0009',
              fontSize: 'inherit',
              position: 'relative',
              top: '12px',
              paddingTop: '10px',
              paddingBottom: '5px',
            }}
          >
            Market Details: <span style={{ color: '#000a' }}>{marketName}</span>
          </Typography>
        </Box>
      )}
      {isSticky && (
        <DashboardNavbar
          overviewDashboardTabs={overviewDashboardTabs}
          dashboardLayoutView={dashboardLayoutView}
        />
      )}
      <TabBar
        tabList={subKpiMetaData}
        currentTab={subKpiSelected}
        color={COLOR_PRIMARY_2}
        renderLabelCondition={() => true}
      />
    </Box>
  );
};

export default OverviewPage;
